import { environment } from '@environments/environment';

export const API_ENDPOINT_BFM = environment.api_url;
export const PAY_API_ENDPOINT_BFM = environment.pay_api_url;
export const URL_CAR_TRAWLER = environment.cartrawler_api_url;
export const CARTRAWLER_CLIENT_ID = environment.cartrawler_client_id;
export const URL_CAR_TRAWLER_CROSS_SELL = environment.cartrawler_crosssell_url;
export const URL_IP_ADDRESS_EXTERNAL_SERVICE = environment.ip_address_svc_url;
// const newEndpoint = PAY_API_ENDPOINT_BFM.includes('myb.flytap.com') ? 'https://tppro' : PAY_API_ENDPOINT_BFM.slice(0, 13);
// export const API_ENDPOINT_PAYMENT = newEndpoint + 'payment.suitairibe.com/';

// default market & language
export const DEFAULT_MARKET = 'PT';
export const DEFAULT_LANGUAGE = 'pt';

export const PAYMENT_POC = environment.payment_poc;
export const PAYPAL_CLIENT_ID = environment.paypal_client_id;
export const PAYPAL_FLOW_ID = environment.paypal_flow_id;
export const PAYPAL_CODE_BLOCK_URL = environment.paypal_code_block_url;
export const PAYPAL_FNS_PARAMS = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99' //STATIC PARAMS

// credentials
export const BFM_CREDENTIALS = {
	clientId: '-bqBinBiHz4Yg+87BN+PU3TaXUWyRrn1T/iV/LjxgeSA=',
	clientSecret: 'DxKLkFeWzANc4JSIIarjoPSr6M+cXv1rcqWry2QV2Azr5EutGYR/oJ79IT3fMR+qM5H/RArvIPtyquvjHebM1Q==',
	referralId: 'h7g+cmbKWJ3XmZajrMhyUpp9.cms35',
	market: DEFAULT_MARKET,
	language: DEFAULT_LANGUAGE,
	userProfile: null,
	appModule: '0',
	idOperation: null
};

// 401 Handling
export const RETRIES_ON_401 = 1;

// Default decimal places for cash
export const DEFAULT_DECIMAL_PLACES = 2;

// apis
// export const URL_ROOT = 'http://tpint.suitairibe.com/bfm/rest/';
export const URL_ROOT_PAYMENT = PAY_API_ENDPOINT_BFM + 'paymentHub/tap/';
export const URL_ROOT_PAYMENT_BFM = PAY_API_ENDPOINT_BFM + 'bfm/rest/';

export const URL_ROOT = API_ENDPOINT_BFM + 'bfm/rest/';
export const URL_BFM_SESSION_CREATE = `${URL_ROOT}session/create`;
export const URL_BFM_PNRS_SEARCH = `${URL_ROOT}booking/pnrs/search`;
export const URL_BFM_PNRS_LIST = `${URL_ROOT}booking/pnrs`;
export const URL_BFM_RESERVATION_MODIFY_CONTACT = `${URL_ROOT}reservation/data/contacts`;
export const URL_ANCILLARIES = `${URL_ROOT}ancillaries/catalog`;
export const URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY = `${URL_ROOT}ancillaries/meals/`;
export const URL_ANCILLARIES_SELECTION = `${URL_ROOT}booking/ancillarieshub`;
export const URL_SHOPPING_CART = `${URL_ROOT}booking/payments/ancillaries/basket`;
export const URL_CONTACT_EDIT = `${URL_ROOT}reservation/data/contacts`;
export const URL_ATC_AVAILABILITY = `${URL_ROOT}booking/atc/availability`;
export const URL_CANCEL_PNR = `${URL_ROOT}reservation/cancelPNR/cancel`;
export const URL_UPDATE_FLIGHT = `${URL_ROOT}booking/pnrs/`;
export const URL_GENERATE_PNR = `${URL_ROOT}booking/pnrs/generate`;
export const URL_PNR_EXTEND = `${URL_ROOT}booking/pnrs/extend`;
export const URL_PNR_REPORT_TO_KIBANA = `${URL_ROOT}booking/pnrs/reportToKibana`;


export const URL_SESSION_RENEW = `${URL_ROOT}session/renew`;
export const URL_SESSION_RESET = `${URL_ROOT}session/resetValues`
export const URL_SESSION_SIGNOUT = `${URL_ROOT}signOut/signOut`;
export const URL_SESSION_EXTEND = `${URL_ROOT}session/extendSession`;

export const URL_BFM_RESERVATION_MODIFY = `${URL_ROOT}reservation/modify`;
export const URL_BFM_RESERVATION_MODIFY_PASSENGERS = `${URL_ROOT}reservation/data/passengers`;

export const URL_LOGIN = `${URL_ROOT}login/digitalCustomer`;
export const URL_DEEPLINK_LOGIN = `${URL_ROOT}login/deeplink`;
export const URL_USER_RESERVATIONS = `${URL_ROOT}login/customerPnrs`;
export const URL_LOGOUT = `${URL_ROOT}loyaltyClient/digitalCustomerLogout`;
export const URL_PAYMENTHUB = `${URL_ROOT}paymenttap/get/payment/method`;
export const URL_PAYMENT_CHECK_FOP = `${URL_ROOT}paymenttap/checkPaymentMethods`;
export const URL_GET_STATUS_TRANSACTION = `${URL_ROOT_PAYMENT_BFM}paymenttap/proccesiframe`;
export const URL_PAYCARD = `${URL_ROOT_PAYMENT}adyen/payment/credit/card/encrypted `;
export const URL_PAYCARD_BOOKING = `${URL_ROOT_PAYMENT}adyen/payment/credit/card/encrypted/bookingflow`;
export const URL_PAYMENT_REDIRECT = `${URL_ROOT_PAYMENT}adyen/payment/redirect`;
export const URL_PAYMENT_IDENTIFYSHOPPER = `${URL_ROOT_PAYMENT}adyen/identifyshopper`;
export const URL_PAYMENT_CHALLANGESHOPPER = `${URL_ROOT_PAYMENT}adyen/challengeshopper`;
export const URL_PAYMENT_DECLINED_VALIDATION = `${URL_ROOT_PAYMENT}notification/declined/validation`;
export const URL_AUTHORISED = `${URL_ROOT_PAYMENT}adyen/authorise3d`;
export const URL_PAYMENT_APPLY_CC_FEE = `${URL_ROOT}paymenttap/applyCcFee?fee=`;
export const URL_DEEPLINK_FLOW = `${URL_ROOT}deeplink/ibe`;
export const URL_REDEEM_VOUCHER = `${URL_ROOT}booking/vouchers/redeemVouchers`; 
export const URL_CHECKOUT_PAYBYRD = `${URL_ROOT_PAYMENT}paybyrd/create/order`;


export const URL_ANAC = `${URL_ROOT}booking/anac`;
export const URL_BOOKING_EXTRA = `${URL_ROOT}booking/extra`;
export const URL_FARE_INFORAMATIONTAC = `${URL_ROOT}booking/pnrs/fare/informationTAC/`;
export const URL_ATC_FARE = `${URL_ROOT}booking/atc/fare`;
export const URL_BOOKING_MARKET = `${URL_ROOT}booking/market`;
export const URL_BOOKING_ADD_TO_MY_ACCOUNT = `${URL_ROOT}customer/modifyCustomerAccount`;
export const URL_BFM_CREATE_CUSTOMER_ACCOUNT = `${URL_ROOT}customer/createCustomerAccount`;
export const URL_BFM_MODIFY_CUSTOMER_ACCOUNT = `${URL_ROOT}customer/modifyCustomerFieldsAccount`;

export const URL_BFM_BOOKING_FLIGHTS_INFO = `${URL_ROOT}booking/flights/info/retrieve`;

export const URL_BOOKING_FARE = `${URL_ROOT}booking/fare`;

// Journey APIs
export const URL_BFM_LOCATION_ORIGIN = `${URL_ROOT}journey/origin/search`;
export const URL_BFM_LOCATION_ORIGIN_MULTICITY = `${URL_ROOT}journey/origin/multicity/search`;
export const URL_BFM_LOCATION_DESTINATION = `${URL_ROOT}journey/destination/search`;

// Continent/Regions APIs
export const URL_BFM_GEOGRAPHY_CONTINENTS = `${URL_ROOT}geography/continents`;
// export const URL_BFM_GEOGRAPHY_CONTINENTS = `${URL_ROOT}geography/continents?`;
export const URL_BFM_GEOGRAPHY_AIRPORTS = `${URL_ROOT}geography/airports`;

// Calendar Price APIs
export const URL_BFM_AVAILABILITY_CALENDAR = `${URL_ROOT}booking/availability/calendar/`;
export const URL_BFM_AVAILABILITY_CALENDAR_RETURNS = `${URL_ROOT}booking/availability/calendarReturns/`;
export const URL_BFM_AVAILABILITY_CALENDAR_LOWEST_MONTH_PRICE = `${URL_ROOT}booking/availability/calendar/prices/lowest/monthly`;

// Booking Availability APIs
export const URL_BFM_BOOKING_AVAILABILITY_SEARCH = `${URL_ROOT}booking/availability/search`;
export const URL_BFM_BOOKING_AVAILABILITY_SELECT = `${URL_ROOT}booking/availability/select`;
export const URL_BFM_BOOKING_AVAILABILITY_SEARCH_MULTICITY = `${URL_ROOT}booking/availability/searchMulti/`;
export const URL_BFM_BOOKING_AVAILABILITY_MULTICITY_PAGINATION = `${URL_ROOT}booking/availability/paginateAvailabilityMulti`;
export const URL_BFM_BOOKING_AVAILABILITY_MULTICITY_SORT_BY = `${URL_ROOT}booking/availability/sortAvailabilityMulti`;
export const URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY_RESET = `${URL_ROOT}booking/availability/resetFiltersAvailabilityMulti`;
export const URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY = `${URL_ROOT}booking/availability/filterAvailabilityMulti`;
export const URL_BFM_BOOKING_AVAILABILITY_FLEX_PRICER = `${URL_ROOT}booking/availability/searchMoreFlights`;
export const URL_BFM_BOOKING_AVAILABILITY_RETRIEVE_MATRIX = `${URL_ROOT}booking/availability/retrieveMatrix`;

export const URL_BFM_BOOKING_CREATE = `${URL_ROOT}booking/pnrs/create`;
export const URL_BFM_BOOKING_ISSUE = `${URL_ROOT}booking/pnrs/issue`;
export const URL_BFM_BOOKING_FARE_BREAKDOWN = `${URL_ROOT}booking/pnrs/faresBreakdownWithoutPnr`;
export const URL_BFM_BOOKING_INFORMATION_MILES = `${URL_ROOT}booking/pnrs/fare/informationMiles`;

// TTT API
export const URL_TIME_TO_THINK = `${URL_ROOT}booking/timetothink/search`;

// TTT Booking redirection
export const TTT_BOOKING_ENDPOINT = `${environment.client_book_url}`;
export const TTT_BOOKING_REDIRECTION_URL = `${TTT_BOOKING_ENDPOINT}air/TAPPT/SearchTimeToThink.aspx`;

// best offers API
export const URL_BEST_OFFERS = API_ENDPOINT_BFM + 'bfm/service/destinations/deals/destinationDealsV2';

// validate promocode API
// export const URL_VALIDATE_PROMO_CODE = `${URL_ROOT}booking/promocodes/verify`;
export const URL_VALIDATE_PROMO_CODE = `${URL_ROOT}booking/promocodes/validate`;
export const URL_PROMOCODE_IN_SESSION = `${URL_ROOT}booking/promocodes/promocodeInSession`;
export const URL_REMOVE_PROMOCODE_IN_SESSION = `${URL_ROOT}booking/promocodes/removePromocodeInSession`;

// validate voucher API
export const URL_VALIDATE_VOUCHER = `${URL_ROOT}booking/vouchers/verify`;
export const URL_VOUCHER_IN_SESSION = `${URL_ROOT}booking/vouchers/vouchersInSession`;
export const URL_REMOVE_VOUCHER_IN_SESSION = `${URL_ROOT}booking/vouchers/removeVoucherInSession`;
export const URL_PARTIAL_VOUCHER = `${URL_ROOT}booking/vouchers/partialVoucher`;
export const URL_VALIDATE_VOUCHER_CODE = `${URL_ROOT}booking/vouchers/validatecode`;

// block tap experience api
export const URL_BLOCK_TAP_EXPERIENCE = `${URL_ROOT}booking/pnrs/fare/informationEconomy`;

// url extensions
export const URL_MARKET_TRANSLATIONS = API_ENDPOINT_BFM + 'bfm/service/common/resources/markets/tp/entity/1/ibe/1';
export const URL_LOCALES = API_ENDPOINT_BFM + 'ibe/admin/model/locales';

// seatmap
export const SEATMAP_SEGMENT_URL_EXTENSION = '/seatmap?segment=';
export const SEATMAP_PACK_SELECTED_URL_EXTENSION = '&packSelected='

export const FLIGHT_MEAL_AVAILABILITY_URL_EXTENSION = '/retrieveFlightMealsAvailability?segment=';

// Passenger Types API
export const URL_AVAILABLE_PASSENGER_TYPES = `${URL_ROOT}search/pax/types?`;

// Stopover API
export const URL_STOPOVER = `${URL_ROOT}journey/stopover/search`;

// Weakflight Info API
export const URL_WEAKFLIGHT_INFO = `${URL_ROOT}booking/pnrs/fare/informationWeakFlights/`;

// External Ancillaries
export const URL_AVAILABILITY_HOTEL = `${URL_ROOT}booking/externalAncillaries/booking/availabilityHotel`;
export const URL_AVAILABILITY_HOTEL_ROOMS = `${URL_ROOT}booking/externalAncillaries/booking/availabilityHotelRooms`;
export const URL_CHUBB_INSURANCE_PLANS = `${URL_ROOT}booking/externalAncillaries/chubb/searchInsurancePlans`;


// External Reservation Ancillaries APIs
export const URL_BFM_EXTERNAL_RESERVATION = `${URL_ROOT}booking/externalAncillaries/reservations/putExternalReservationInSession`;
export const URL_REMOVE_EXTERNAL_RESERVATION = `${URL_ROOT}booking/externalAncillaries/reservations/removeExternalReservation/`;
export const URL_REMOVE_ALL_EXTERNAL_RESERVATION = `${URL_ROOT}booking/externalAncillaries/reservations/removeAllExternalReservation`;
export const URL_REMOVE_SPECIFIC_EXTERNAL_RESERVATION = `${URL_ROOT}booking/externalAncillaries/reservations/removeSpecificExternalReservation/`;
export const URL_REMOVE_EXTERNAL_RESERVATION_BY_EXTRA_INFO = `${URL_ROOT}booking/externalAncillaries/reservations/removeExternalReservationByExtraInfo/`;

// Booking Search Passenger APIs
export const URL_CREATE_UPDATE_NEW_PASSENGER = `${URL_ROOT}booking/pnrs/passengers/apis/createPassenger`;
export const URL_RETRIEVE_NEW_PASSENGER = `${URL_ROOT}booking/pnrs/passengers/apis/retrievePassenger?passengerId=`;
export const URL_RETRIEVE_COMPANION_LIST = `${URL_ROOT}booking/pax/retrieveCompanionList`;

// Booking search Contact APIs
export const URL_CREATE_UPDATE_NEW_CONTACT = `${URL_ROOT}booking/pnrs/passengers/apis/createContact`;
export const URL_RETRIEVE_NEW_CONTACT = `${URL_ROOT}booking/pnrs/passengers/apis/retrieveContact`;
export const URL_RETRIEVE_FLY_PROGRAMS = `${URL_ROOT}booking/pnrs/passengers/starAlliance/retrieveFlyPrograms`;

// Ancillaries
export const URL_ANCILLARIES_APPLY_ALL_FLIGHTS = `${URL_ROOT}booking/ancillarieshub/applyAllFlights`;

// Slider Miles Convertion Rate
export const URL_MILES_CONVERSION_RATE = `${URL_ROOT}loyaltyClient/points/conversionRate`;
export const URL_MILES_USE_MILES = `${URL_ROOT}loyaltyClient/useMiles?amount=`;

// MGP Bottom Banner API
export const URL_REMOVE_MILES_DISCOUNT = `${URL_ROOT}profile/removeMilesDicount`;
export const URL_ADD_MILES_DISCOUNT = `${URL_ROOT}profile/activeMilesDicount`;

// Bus
export const URL_BUS_STOPS_AVAILABILITY = `${URL_ROOT}booking/nonFlightStops?`;

// Paypal Payment APIs
export const URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP = `${URL_ROOT_PAYMENT}paypal/create/billing/agreement`;
export const URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP = `${URL_ROOT_PAYMENT}paypal/capture/order/ocp`;
export const URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL = `${URL_ROOT_PAYMENT}paypal/capture/order`;
export const URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL = `${URL_ROOT_PAYMENT}paypal/create/order`;

// PRP Payment API
export const URL_PAYMENT_PRP_CREATE_ORDER = `${URL_ROOT_PAYMENT}prp/create/order`;

// Multicaixa Payment API
export const URL_PAYMENT_MULTICAIXA = `${URL_ROOT_PAYMENT}multicaixa/create/reference`;

export const URL_PAYMENT_WITHOUT_GATEWAY = `${URL_ROOT_PAYMENT}payment/without/gateway`;

// Saved CC Card Removal API
export const URL_PAYMENT_REMOVE_SAVED_CARD = `${URL_ROOT_PAYMENT}adyen/disable`;


// Car Trawler
export const URL_CAR_TRAWLER_IFRAME = `${URL_CAR_TRAWLER}/smartblock/iframes/tap.html?`;
export const URL_CAR_TRAWLER_IFRAME_MOBILE = `${URL_CAR_TRAWLER}/smartblock/iframes/tap.html?device=mobile`;

// Params
export const URL_RETRIEVE_PARAMS = `${URL_ROOT}/booking/pnrs/getParamByName`

export const PAYMENT_APIS_NO_RETRY = [
	URL_PAYCARD_BOOKING,
	URL_PAYMENT_REDIRECT,
	URL_PAYMENT_PRP_CREATE_ORDER,
	URL_PAYMENT_MULTICAIXA,
	URL_PAYMENT_WITHOUT_GATEWAY,
	URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP,
	URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL,
	URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL,
	URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP,
	URL_BFM_BOOKING_CREATE
];

// state config
export const INDRA_CA_STATES_URL =
	'./assets/data/indra_ca_states.json';
export const INDRA_BR_STATES_URL =
	'./assets/data/indra_br_states.json';
export const INDRA_AU_STATES_URL =
	'./assets/data/indra_au_states.json';
export const INDRA_AR_STATES_URL =
	'./assets/data/indra_ar_states.json';
export const INDRA_US_STATES_URL =
	'./assets/data/indra_us_states.json';
export const INDRA_AU_STATES_CREATE_ACCOUNT_URL =
	'./assets/data/indra_create_acct_au_states.json';
export const INDRA_AR_STATES_CREATE_ACCOUNT_URL =
	'./assets/data/indra_create_acct_ar_states.json';

// mock urls
export const MOCK_URL_BFM_BOOKED_TRIPS_LIST =
	'./assets/data/indra_booked_trips_list.json';
export const MOCK_URL_BFM_BOOKED_TRIP_SEARCH =
	'./assets/data/indra_booked_trip_search.json';
export const MOCK_URL_BFM_ANCILLARIES =
	'./assets/data/indra_ancillaries_list.json';
export const MOCK_URL_ATC_AVAILABILITY =
	'./assets/data/indra_atc_availability.json';
export const MOCK_LOGIN =
	'./assets/data/indra_user_login.json';
export const MOCK_URL_USER_RESERVATION =
	'./assets/data/indra_user_pnrs.json';
export const MOCK_URL_LOGOUT =
	'./assets/data/indra_logout.json';
export const MOCK_URL_SEATMAP =
	'./assets/data/indra_seatmap.json';
export const MOCK_URL_ANAC =
	'./assets/data/indra_anac.json';
export const MOCK_URL_HEADER_MENU =
	'./assets/data/indra_header_menu.json';
export const MOCK_URL_FOOTER =
	'./assets/data/footer.json';
export const MOCK_URL_BOOKING_EXTRA =
	'./assets/data/ancillaries.json';
export const MOCK_URL_TOTAL_SUMMARY =
	'./assets/data/fare-ad-taxes.json';
export const MOCK_URL_FARE_INFORAMATIONTAC =
	'./assets/data/indra_brand_ancillaries.json';
export const MOCK_URL_ATC_FARE =
	'./assets/data/indra_atc_fare.json';
export const MOCK_URL_UPGRADE_WITH_MILES =
	'./assets/data/indra_upgrade_with_miles.json';
export const MOCK_URL_CURRENCY =
	'./assets/data/indra_currency_list.json';
export const MOCK_URL_ENCRYPTED_AUTHORIZE =
	'./assets/data/encrypted_authorize.json';
export const MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_ERROR =
	'./assets/data/encrypted_authorize_issue_error.json';
export const MOCK_URL_ENCRYPTED_AUTHORIZE_ISSUE_KO =
	'./assets/data/encrypted_authorize_issue_ko.json';
export const MOCK_URL_ENCRYPTED_REDIRECTSHOPPER =
	'./assets/data/encrypted_redirectShopper.json';
export const MOCK_URL_ENCRYPTED_IDENTIFYSHOPPER =
	'./assets/data/encrypted_identifyShopper.json';
export const MOCK_URL_ENCRYPTED_REFUSED =
	'./assets/data/encrypted_refused.json';
export const MOCK_URL_ENCRYPTED_REJECTED_CYBERSOURCE =
	'./assets/data/encrypted_rejected_cybersource.json';
export const MOCK_URL_ENCRYPTED_REJECTED_FCE =
	'./assets/data/encrypted_rejected_fce.json';
export const MOCK_URL_ENCRYPTED_REJECTED_FCE_A =
	'./assets/data/encrypted_rejected_fce_a.json';
export const MOCK_URL_ENCRYPTED_REVIEW =
	'./assets/data/encrypted_review.json';
export const MOCK_URL_ENCRYPTED_REVIEW_FCE =
	'./assets/data/encrypted_review_fce.json';
export const MOCK_URL_ENCRYPTED_REDIRECTSHOPPER_OTHER_FOPS =
	'./assets/data/encrypted_redirectShopper_other_FOPs.json';
export const MOCK_URL_PAYMENT_ALIPAY =
	'./assets/data/payment-alipay.json';
export const MOCK_URL_PAYMENT_PRP =
	'./assets/data/encrypted_atm_mbway.json';
export const MOCK_URL_PAYMENT_MULTICAIXA =
	'./assets/data/encrypted_multicaixa.json';
export const MOCK_URL_PAYMENT_BANKTRANSFER_PICKUP =
	'./assets/data/encrypted_banktransfer_pickup.json';
export const MOCK_URL_PAYMENT_TRANSACTION_STATUS =
	'./assets/data/payment_transaction_status.json';
export const MOCK_URL_PAYMENT_METHOD =
	'./assets/data/payment.method.indra.json';
export const MOCK_URL_PAYMENT_DELETE_SAVED_CARD =
	'./assets/data/payment_delete_saved_card.indra.json';
export const MOCK_URL_PAYMENT_CHECK_FOP =
	'./assets/data/payment_check_fop.indra.json';
export const MOCK_URL_PAYMENT_CC_FEE =
	'./assets/data/payment_cc_fee.indra.json';
export const MOCK_URL_PAYMENT_CC_FEE_ZERO =
	'./assets/data/payment_cc_fee_zero.indra.json';
export const MOCK_URL_ORIGINS =
	'./assets/data/airports.origins.indra.json';
export const MOCK_URL_DESTINATIONS =
	'./assets/data/airports.destinations.indra.json';
export const MOCK_URL_DESTINATIONS_PAY_WITH_MILES_ONLY =
	'./assets/data/airports.destinations.paywithmiles.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_JAN =
	'./assets/data/availability.calendar.outbound.price.jan.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_FEB =
	'./assets/data/availability.calendar.outbound.price.feb.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_MAR =
	'./assets/data/availability.calendar.outbound.price.mar.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_APR =
	'./assets/data/availability.calendar.outbound.price.apr.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_MAY =
	'./assets/data/availability.calendar.outbound.price.may.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_JUN =
	'./assets/data/availability.calendar.outbound.price.jun.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_JUL =
	'./assets/data/availability.calendar.outbound.price.jul.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_AUG =
	'./assets/data/availability.calendar.outbound.price.aug.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_SEP =
	'./assets/data/availability.calendar.outbound.price.sep.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_OCT =
	'./assets/data/availability.calendar.outbound.price.oct.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_NOV =
	'./assets/data/availability.calendar.outbound.price.nov.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_DEC =
	'./assets/data/availability.calendar.outbound.price.dec.indra.json';
export const MOCK_URL_AVAILABILITY_CALENDAR_RETURNS =
	'./assets/data/availability.calendar.inbound.price.indra.json';
export const MOCK_URL_AVAILABLE_PASSENGER_TYPE =
	'./assets/data/passenger.type.indra.json';
export const MOCK_URL_AVAILABLE_PASSENGER_TYPE_UK_MARKET =
	'./assets/data/passenger.type.uk.market.indra.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH =
	'./assets/data/booking.availability.search.indra.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SELECT =
	'./assets/data/booking.availability.select.indra.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_BOTH =
	'./assets/data/booking.availability.search-stopover-both.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_OUTBOUND =
	'./assets/data/booking.availability.search-stopover-outbound.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_INBOUND =
	'./assets/data/booking.availability.search-stopover-inbound.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY =
	'./assets/data/booking.availability.search.multicity.json';
export const MOCK_URL_BEST_OFFERS =
	'./assets/data/best-offers.indra.json';
export const MOCK_URL_STOPOVERS =
	'./assets/data/available-stopover.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_WAITLIST =
	'./assets/data/booking.availability.search-stopover-waitlist.json';
export const MOCK_URL_VOUCHER_OK =
	'./assets/data/vouchers-ok.json';
export const MOCK_URL_VOUCHER_ERROR =
	'./assets/data/vouchers-error.json';
export const MOCK_URL_VOUCHER_NOT_FOUND =
	'./assets/data/vouchers-not-found.json';
export const MOCK_URL_PROMOCODE_OK =
	'./assets/data/promocode-ok.json';
export const MOCK_URL_VALIDATE_VOUCHER_CODE_OK = 
	'./assets/data/validate-code-ok.json';
export const MOCK_URL_VALIDATE_VOUCHER_CODE_NOK = 
	'./assets/data/validate-code-nok.json';
export const MOCK_URL_RETRIEVE_FLIGHT_MEALS_AVAILABILITY =
	'./assets/data/retrieve_flight_meals_availability.json';
export const MOCK_CALENDAR_LOWEST_MONTH_PRICE =
	'./assets/data/calendar-monthly-lowest-price.json';
export const MOCK_URL_CONTINENTS =
	'./assets/data/continents.indra.json';
export const MOCK_URL_AIRPORTS =
	'./assets/data/airports.indra.json';
export const MOCK_URL_FLIGHT_INFO =
	'./assets/data/flight_info.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_211 =
	'./assets/data/booking-availability.search.211.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_PAY_WITH_MILES =
	'./assets/data/booking-availability.search.payWithMiles.json';
export const MOCK_URL_PAYMENTS_BY_MARKET =
	'./assets/data/payment.method.json';
export const MOCK_URL_BOOKING_FARE =
	'./assets/data/booking.fare.indra.json';
export const MOCK_URL_FARE_INFORAMATIONTAC_EXTRA_ECONOMY =
	'./assets/data/indra_brand_ancillaries.extraeconomy.json';
export const MOCK_URL_SESSION =
	'./assets/data/session.indra.json';
export const MOCK_URL_EXTEND_SESSION =
	'./assets/data/extend_session.indra.json';
export const MOCK_URL_MARKET_LIST =
	'./assets/data/market_list.indra.json';
export const MOCK_URL_BOOKING_MARKET =
	'./assets/data/booking_market.indra.json';
export const MOCK_URL_BFM_GENERATE_PNR =
	'./assets/data/indra_generate_dummy_pnr.json';
export const MOCK_URL_BFM_GENERATE_PNR_VIEW =
	'./assets/data/indra_generate_for_view.json';
export const MOCK_URL_BFM_GENERATE_TTT_PNR_FOR_COMPLETION =
	'./assets/data/indra_generate_for_TTT_completion.json';
export const MOCK_URL_BFM_GENERATE_TTT_PNR_FOR_COMPLETION_EMPTY_FLIGHTS =
	'./assets/data/indra_generate_for_TTT_completion_empty_flights.json';
export const MOCL_URL_TIME_TO_THINK =
	'./assets/data/indra_time_to_think.json';
export const MOCK_URL_WEAKFLIGHT_INFO =
	'./assets/data/weakflight-info.json';
export const MOCK_URL_FARE_TAXES_BREAKDOWN =
	'./assets/data/fare-taxes-breakdown.indra.json';
export const MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STAR_ALLIANCE =
	'./assets/data/booking-availability.search.starAlliance.json';
export const MOCK_URL_INFORMATION_ECONOMY =
	'./assets/data/information-economy.json';
export const MOCK_URL_FARE_INFORMATION_MILES =
	'./assets/data/fare-information-miles.indra.json';
export const MOCK_URL_AVAILABILITY_HOTEL =
	'./assets/data/booking.availability.hotel.json';
export const MOCK_URL_AVAILABILITY_HOTEL_ROOMS =
	'./assets/data/booking.availability.hotel.rooms.json';
export const MOCK_URL_AVAILABILITY_HOTEL_PROPERTIES_AND_FACILITIES =
	'./assets/data/booking.availability.hotel.properties.and.facilities.json';
export const MOCK_URL_CARBON_OFFSET =
	'./assets/data/carbon-offset-ancillary.json';
export const MOCK_URL_CREATE_NEW_PASSENGER_INFO =
	'./assets/data/indra-create_new_passenger_info.json';
export const MOCK_URL_CREATE_NEW_PNR_CONTACT =
	'./assets/data/indra-create_new_pnr_contact.json';
export const MOCK_URL_CHUBB_INSURANCE_PLANS =
	'./assets/data/chubb.insurance.plans.json';
export const MOCK_URL_INSURANCE_RESERVATIONS =
	'./assets/data/insurance-reservations.json';
export const MOCK_URL_MILES_CONVERSION_RATE =
	'./assets/data/miles.conversion.rate.json';
export const MOCK_URL_BUS_STOPS =
	'./assets/data/bus-stops.json';
export const MOCK_URL_LISBOA_CARD =
	'./assets/data/lisboa-card.json';
export const MOCK_URL_AIRPORT_TRANSFERS =
	'./assets/data/airport-transfers.json';
export const MOCK_URL_SIGHTSEEING_TOURS =
	'./assets/data/sightseeing-tours.json';
export const MOCK_URL_DANISH_FUND =
	'./assets/data/danish-fund.json';
export const MOCK_URL_CUSTOMER_ACCOUNT =
	'./assets/data/customer-account.json';
export const MOCK_URL_UPGRADE_ACCOUNT_OK =
	'./assets/data/upgrade-miles-and-go-ok.json';
export const MOCK_URL_UPGRADE_ACCOUNT_ERROR =
	'./assets/data/upgrade-miles-and-go-error.json';
export const MOCK_URL_DEEPLINK_FLOW =
	'./assets/data/deeplink-flow.json';
export const MOCK_URL_DUPLICATE_BOOKING =
	'./assets/data/duplicate-booking.json';
export const MOCK_URL_BOOKING_ANCILLARIES_ERROR =
	'./assets/data/create-booking-ancillaries-error.json';
export const MOCK_URL_FARE_BREAKDOWN_VIEW =
	'./assets/data/fare-breakdown-view.json';
export const MOCK_URL_UPDATE_ANCILLARY_PAYMENT_TYPE =
	'./assets/data/update_payment_type.json';
export const MOCK_URL_BOOKING_AVAILABILITY_RETRIEVE_MATRIX =
	'./assets/data/availability.matrix.panel.json';
export const MOCK_URL_REDEEM_VOUCHER =
	'./assets/data/redeem-voucher.indra.json';
export const MOCK_URL_FLY_PROGRAMS =
	'./assets/data/fly-programs.indra.json';
export const MOCK_URL_PARAMS =
	'./assets/data/params.indra.json';
export const MOCK_URL_COMPANION_LIST =
	'./assets/data/companion-list.indra.json';
export const MOCK_PAYBYRD_CHECKOUT =
	'./assets/data/paybyrd-checkout.indra.json';
export const MOCK_ANCILLARIES_HUB_RESPONSE =
	'./assets/data/ancillaries_hub_response.indra.json'
export const MOCK_ANCILLARIES_HUB_BUNDLES_RESPONSE =
	'./assets/data/ancillaries_hub_bundles_response.indra.json'

// trip types codes and descriptions
export const TRIP_TYPE_ONE_WAY_CODE = 'O';
export const TRIP_TYPE_ROUND_TRIP_CODE = 'R';
export const TRIP_TYPE_MULTICITY_CODE = 'M';
export const TRIP_TYPE_HAS_STOP_OVER_CODE = 'S';

export const TRIP_TYPE_ONE_WAY_DESCRIPTION = 'One way';
export const TRIP_TYPE_ROUND_TRIP_DESCRIPTION = 'Round trip';
export const TRIP_TYPE_MULTICITY_DESCRIPTION = 'Multicity';
export const TRIP_TYPE_HAS_STOP_OVER_DESCRIPTION = 'Stopover';
/*

export const TRIP_TYPE_ONE_WAY_DESCRIPTION_TP = 'Mão única';
export const TRIP_TYPE_ROUND_TRIP_DESCRIPTION_TP = 'Ida e volta';
export const TRIP_TYPE_MULTICITY_DESCRIPTION_TP = 'Multi-cidade';
export const TRIP_TYPE_HAS_STOP_OVER_DESCRIPTION_TP = 'Escala';
export const TRIP_TYPE_MULTICITY = 'Multicity trip';
export const TRIP_TYPE_MULTICITY_TP = 'Viagem pela cidade';
*/

// passenger type codes and description
export const PAX_TYPE_ADULT_CODE = 'ADT';
export const PAX_TYPE_CHILD_CODE = 'CHD';
export const PAX_TYPE_INFANT_CODE = 'INF';
export const PAX_TYPE_YOUNG_ADULT_CODE = 'YTH';

export const PAX_TYPES = [PAX_TYPE_ADULT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_INFANT_CODE, PAX_TYPE_YOUNG_ADULT_CODE];

// passenger type
export const PAX_TYPE_ADULT = 'adults';
export const PAX_TYPE_CHILD = 'children';
export const PAX_TYPE_INFANT = 'infants';
export const PAX_TYPE_YOUNG_ADULT = 'youngAdults';

export const PASSENGER_TYPE_TO_CODE_MAP = {
	[PAX_TYPE_ADULT]: PAX_TYPE_ADULT_CODE,
	[PAX_TYPE_CHILD]: PAX_TYPE_CHILD_CODE,
	[PAX_TYPE_INFANT]: PAX_TYPE_INFANT_CODE,
	[PAX_TYPE_YOUNG_ADULT]: PAX_TYPE_YOUNG_ADULT_CODE
};

// status book codes
export const STATUS_BOOK_ACTIVE_CODE = 'ok';
export const STATUS_BOOK_CANCELLED_CODE = 'cancelled';
export const STATUS_BOOK_UNFINISHED_CODE = 'unfinished';
export const STATUS_BOOK_PENDING_CODE = 'pending';
export const STATUS_BOOK_PAST_CODE = 'flown';
export const STATUS_BOOK_CONFIRMED = 'confirmed';
export const STATUS_BOOK_CHANGED = 'changed';

// stop time threshold for stop over (minutes)
// export const STOP_OVER_THRESHOLD_IN_MINS = 1440;
export const MINIMUM_TIME_BETWEEN_FLIGHTS = 60;

// Portugal country
export const COUNTRY_PORTUGAL = 'Portugal';
export const COUNTRY_CODE_PORTUGAL = 'PT';
// Colombia country
export const COUNTRY_COLOMBIA = 'Colombia';
export const COUNTRY_CODE_COLOMBIA = 'CO';
// USA country
export const COUNTRY_USA = 'USA';
export const COUNTRY_CODE_USA = 'US';
// Canada country
export const COUNTRY_CANADA = 'CANADA';
export const COUNTRY_CODE_CANADA = 'CA';
// Venezuela Country
export const COUNTRY_VENEZUELA = 'Venezuela';
export const COUNTRY_CODE_VENEZUELA = 'VE';
// Brazil Country
export const COUNTRY_BRAZIL = 'Brazil';
export const COUNTRY_CODE_BRAZIL = 'BR';
// Egypt Country
export const COUNTRY_EGYPT = 'Egypt';
export const COUNTRY_CODE_EGYPT = 'EG';
// Turkey Country
export const COUNTRY_TURKEY = 'Turkey';
export const COUNTRY_CODE_TURKEY = 'TR';
// China Country
export const COUNTRY_CHINA = 'China';
export const COUNTRY_CODE_CHINA = 'CN';
// Great Britain / UK Country
export const COUNTRY_CODE_UNITED_KINGDOM = 'GB';
// Ireland 
export const COUNTRY_CODE_IRELAND = 'IE';
// Denmark
export const COUNTRY_CODE_DENMARK = 'DK';
// Hungary
export const COUNTRY_CODE_HUNGARY = 'HU';
// Italy
export const COUNTRY_CODE_ITALY = 'IT';
// Cape Verde
export const COUNTRY_CODE_CAPE_VERDE = 'CV';
// Ivory Cost
export const COUNTRY_CODE_IVORY_COAST = 'CI';
// Ghana
export const COUNTRY_CODE_GHANA = 'GH';
// Guinea Bissau
export const COUNTRY_CODE_GUINEA_BISSAU = 'GW';
// Mozambique
export const COUNTRY_CODE_MOZAMBIQUE = 'MZ';
// Sao Tome
export const COUNTRY_CODE_SAO_TOME = 'ST';
// Senegal
export const COUNTRY_CODE_SENEGAL = 'SN';
// Togo
export const COUNTRY_CODE_TOGO = 'TG';
// Angola
export const COUNTRY_CODE_ANGOLA = 'AO';
// Morocco
export const COUNTRY_CODE_MOROCCO = 'MA';


// Fare Family
export const FARE_FAMILY_CODE_LITE = 'FFECOLTL1';
export const FARE_FAMILY_CODE_CLASSIC = 'FFECOCLC2';
export const FARE_FAMILY_CODE_FLEX = 'FFECOFLF3';
export const FARE_FAMILY_CODE_ECONOMY_SPECIAL = 'WWFFECO0';
export const FARE_FAMILY_CODE_ECONOMY_BASIC = 'WWFFECO1';
export const FARE_FAMILY_CODE_ECONOMY_FLEXIBLE = 'WWFFECO2';
export const FARE_FAMILY_CODE_PREMIUM_BASIC = 'WWFFPEY1';
export const FARE_FAMILY_CODE_PREMIUM_FLEXIBLE = 'WWFFPEY2';
export const FARE_FAMILY_CODE_BUSINESS_BASIC = 'WWFFBUS1';
export const FARE_FAMILY_CODE_BUSINESS_FLEXIBLE = 'WWFFBUS2';

// TAP Miles & Go Tier Levels
export const TAP_MILES_AND_GO_GOLD = 'GOLD';
export const TAP_MILES_AND_GO_SILVER = 'SILV';
export const TAP_MILES_AND_GO_MILES = 'MILES';
export const TAP_MILES_AND_GO_NAVIGATOR = 'NVGT';
export const TAP_MILES_AND_GO_MILS = 'MILS';

// Header Logo TAP Club
export const TAP_HEADER_CLUB_TAP_DIAMOND = 'DIAMOND';
export const TAP_HEADER_CLUB_TAP_PLATINUM_PLUS = 'PLATINUM_PLUS';
export const TAP_HEADER_CLUB_TAP_PLATINUM = 'PLATINUM';
export const TAP_HEADER_CLUB_TAP_TOP = 'TOP';
export const TAP_HEADER_CLUB_TAP_EXTRA = 'EXTRA';
export const TAP_HEADER_CLUB_TAP_BASIC = 'BASIC';

// Header Logo TAP Miles & Go Tier Levels
export const TAP_HEADER_MILES_AND_GO_GOLD = 'Gold';
export const TAP_HEADER_MILES_AND_GO_SILVER = 'Silver';
export const TAP_HEADER_MILES_AND_GO_MILES = 'Miles';
export const TAP_HEADER_MILES_AND_GO_NAVIGATOR = 'Navigator';
export const TAP_HEADER_MILES_AND_GO_HONORARY_GOLD = 'Honorary Gold';
export const TAP_HEADER_MILES_AND_GO_MILS = 'Mils';

// passanger tier label
export const TAP_MILES_AND_GO_GOLD_LABEL = 'TAP Miles&Go GOLD';
export const TAP_MILES_AND_GO_SILVER_LABEL = 'TAP Miles&Go SILVER';
export const TAP_MILES_AND_GO_MILES_LABEL = 'TAP Miles&Go';
export const TAP_MILES_AND_GO_NAVIGATOR_LABEL = 'TAP Miles&Go NAVIGATOR';

export const TAP_MILES_AND_GO_FF_TIER_LEVELS = [
	TAP_MILES_AND_GO_GOLD,
	TAP_MILES_AND_GO_SILVER,
	TAP_MILES_AND_GO_MILES,
	TAP_MILES_AND_GO_NAVIGATOR,
	TAP_MILES_AND_GO_MILS
];

export const TAP_MILES_AND_GO_FF_TIER_LEVELS_HIERARCHY = [
	TAP_MILES_AND_GO_NAVIGATOR,
	TAP_MILES_AND_GO_GOLD,
	TAP_MILES_AND_GO_SILVER,
	TAP_MILES_AND_GO_MILES,
	TAP_MILES_AND_GO_MILS
];

export const TAP_MILES_AND_GO_FF_TIER_LEVELS_ALT = [
	TAP_HEADER_MILES_AND_GO_GOLD,
	TAP_HEADER_MILES_AND_GO_SILVER,
	TAP_HEADER_MILES_AND_GO_MILES,
	TAP_HEADER_MILES_AND_GO_NAVIGATOR,
	TAP_HEADER_MILES_AND_GO_HONORARY_GOLD,
	TAP_HEADER_MILES_AND_GO_MILS
];

// Airline names
export const AIR_LINE_CODE_TAP = 'TP';
export const AIR_LINE_NAME_TAP = 'TAP Air Portugal';
export const AIR_LINE_CODE_AZUL = 'Azul';
export const AIR_LINE_NAME_AZUL = 'Azul Linhas Aéreas Brasileiras';
export const BUS_TRN_OPERATOR = 'Deutsche Bahn';

// For Awards companion lists
export const PAX_TYPE_SPONSOR = 'Sponsor';
export const EMPTY_SPACE = ' ';

// activation of mock
export const MOCK_STATUS = {
	SESSION: false,
	MARKET_LIST: false,
	BOOKING_MARKET: false,
	BOOKING_LIST: false,
	BOOKING_SEARCH: false,
	PASSENGER: false,
	ANCILLARIES_CATALOG: false,
	ANCILLARIES_SELECTION: false,
	BUNDLES_SELECTION: false,
	ATC_AVAILABILITY: false,
	SEAT_MAP: false,
	FOOTER: false,
	ANAC: false,
	HEADER_MENU: false,
	BOOKING_EXTRA: false,
	RETRIEVE_FLIGHT_MEALS_AVAILABILITY: false,
	TOTAL_SUMMARY: false,
	FARE_INFORAMATIONTAC: false,
	ATC_FARE: false,
	UPGRADE_WITH_MILES: false,
	DEEPLINK_LOGIN: false,
	LOGIN: false,
	LOGOUT: false,
	ENCRYPTED: false,
	PAYMENT_TRANSACTION_STATUS: false,
	PAYMENT_METHOD: false,
	PAYMENT_PRP: false,
	PAYMENT_MULTICAIXA: false,
	PAYMENT_MULTICAIXA_EXPRESS: false,
	PAYMENT_BANKTRANSFER_PICKUP: false,
	PAYMENT_REMOVE_SAVED_CARD: false,
	PAYMENT_CHECK_FOP: false,
	PAYMENT_CC_FEE: false,
	ORIGINS: false,
	MULTICITY_ORIGINS: false,
	DESTINATIONS: false,
	AVAILABILITY_CALENDAR: false,
	AVAILABILITY_CALENDAR_RETURNS: false,
	PASSENGER_TYPE: false,
	BOOKING_AVAILABILITY_SEARCH: false,
	BOOKING_AVAILABILITY_SELECT: true,
	BOOKING_AVAILABILITY_SEARCH_MULTICITY: false,
	BOOKING_AVAILABILITY_MATRIX_PANEL: false,
	STOPOVER: false,
	CALENDAR_LOWEST_MONTH_PRICE: false,
	CONTINENTS: false,
	AIRPORTS: false,
	BEST_OFFERS: false,
	PROMOCODE_VOUCHER: false,
	VOUCHER_CODE: false,
	FLIGHT_INFO: false,
	BOOKING_AVAILABILITY_SEARCH_211: false,
	BOOKING_FARE: false,
	FARE_INFORMATIONTAC_EXTRAECONOMY: false,
	BOOKING_GENERATE_PNR: false,
	BOOKING_GENERATE_PNR_VIEW: false,
	BOOKING_FARE_BREAKDOWN_VIEW: false,
	BOOKING_GENERATE_TTT_PNR_FOR_COMPLETION: false,
	TIME_TO_THINK: false,
	PAYMENT_REDIRECT: false,
	WEAK_FLIGHT_INFO: false,
	FARE_TAXES_BREAKDOWN: false,
	INFORMATION_ECONOMY: false,
	FARE_INFORMATION_MILES: false,
	AVAILABILITY_HOTEL: false,
	AVAILABILITY_HOTEL_ROOMS: false,
	CARBON_OFFSET: false,
	NEW_PASSENGER_INFO: false,
	NEW_PNR_CONTACT: false,
	CHUBB_INSURANCE_PLANS: false,
	INSURANCE: false,
	MILES_CONVERSION_RATE: false,
	BUS_STOPS: false,
	LISBOA_CARD: false,
	AIRPORT_TRANSFERS: false,
	SIGHTSEEING_TOURS: false,
	DANISH_FUND: false,
	CUSTOMER_ACCOUNT: false,
	UPGRADE_ACCOUNT: false,
	DEEPLINK_FLOW: false,
	CREATE_BOOKING: false,
	UPDATE_ANCILLARY_PAYMENT_TYPE: false,
	REDEEM_VOUCHER: false,
	FLY_PROGRAMS: false,
	PARAMS: false,
	COMPANION_LIST: false,
	PAYBYRD_CHECKOUT: false
};

// Generic message for API Error
export const API_ERROR_GENERIC_MESSAGE =
	'Oops! something went wrong, please contact support.';

// Checkin statuses
export const CHECK_IN_STATUS_DONE = 'DONE';
export const CHECK_IN_STATUS_PENDING = 'PENDING';
export const CHECK_IN_STATUS_OPEN = 'OPEN';
export const CHECK_IN_STATUS_CLOSED = 'CLOSED';
export const CHECK_IN_STATUS_INVALID = 'INVALID';

// Checkin configurable subtrahend in hours
export const CHECK_IN_STATUS_SUBTRAHEND = 24;

// Checking the differents status codes
export const STATUS_CODE_CANCELLED = '21';
export const STATUS_CODE_CONFIRMED = '39';

// Checking the pnr's office data
export const TAP_GDS_OFFICE_PATTERN = 'TP0';
export const EXPEDIA_GDS_OFFICE_PATTERN = ''; // NOTE: not in phase 1 app config
export const EDREAMS_GDS_OFFICE_PATTERN = ''; // NOTE: not in phase 1 app config
export const OPODO_GDS_OFFICE_PATTERN = ''; // NOTE: not in phase 1 app config

// ancillary product type
export const ANCILLARY_PRODUCT_ANIMALS = 'ANIMAL';
export const ANCILLARY_PRODUCT_BAGGAGE = 'BAG';
export const ANCILLARY_PRODUCT_FAST_TRACK = 'FASTTRACK';
export const ANCILLARY_PRODUCT_LOUNGE = 'LOUNGE';
export const ANCILLARY_PRODUCT_MEAL = 'MEAL';
export const ANCILLARY_PRODUCT_MUSICAL = 'MUSICAL';
export const ANCILLARY_PRODUCT_SEAT = 'SEAT';
export const ANCILLARY_PRODUCT_SPORTS_EQUIPMENT = 'EQUIPMENT';
export const ANCILLARY_PRODUCT_TIME_TO_THINK = 'TIME TO THINK';
export const ANCILLARY_PRODUCT_TRIP_INSURANCE = 'INSURANCE';
export const ANCILLARY_PRODUCT_UPGRADE = 'UPGRADE';
export const ANCILLARY_PRODUCT_VOUCHER = 'VOUCHER';
export const ANCILLARY_PRODUCT_PREF_BOARD = 'PREFERRED_BOARDING';
export const ANCILLARY_PRODUCT_PACK_PAAG = 'PAAG';
export const ANCILLARY_PRODUCT_PACK_PAAD = 'PAAD';
export const ANCILLARY_PRODUCT_PACK_PAAE = 'PAAE';
export const ANCILLARY_PRODUCT_PACK_PAAF = 'PAAF';
export const ANCILLARY_PRODUCT_PACK_PAAC = 'PAAC';
export const ANCILLARY_PRODUCT_PACK_PAAH = 'PAAH';
export const ANCILLARY_PRODUCT_PACK_PAAO = 'PAAO';
export const ANCILLARY_PRODUCT_PACK_PAAT = 'PAAT';
export const ANCILLARY_PRODUCT_PACK_PAAB = 'PAAB';
export const ANCILLARY_PRODUCT_PACK_PAAA = 'PAAA';
export const ANCILLARY_PRODUCT_PACK_PAAI = 'PAAI';
export const ANCILLARY_PRODUCT_PACK_PAAQ = 'PAAQ';
export const ANCILLARY_PRODUCT_PACK_PAAR = 'PAAR';
export const ANCILLARY_PRODUCT_PACK_PBAT = 'PBAT';
export const ANCILLARY_PRODUCT_PACK_PBAA = 'PBAA';
export const ANCILLARY_PRODUCT_PACK_PBAB = 'PBAB';
export const ANCILLARY_PRODUCT_PACKS = [
	ANCILLARY_PRODUCT_PACK_PAAG,
	ANCILLARY_PRODUCT_PACK_PAAD,
	ANCILLARY_PRODUCT_PACK_PAAE,
	ANCILLARY_PRODUCT_PACK_PAAF,
	ANCILLARY_PRODUCT_PACK_PAAC,
	ANCILLARY_PRODUCT_PACK_PAAH,
	ANCILLARY_PRODUCT_PACK_PAAO,
	ANCILLARY_PRODUCT_PACK_PAAT,
	ANCILLARY_PRODUCT_PACK_PAAB,
	ANCILLARY_PRODUCT_PACK_PAAA,
	ANCILLARY_PRODUCT_PACK_PAAI,
	ANCILLARY_PRODUCT_PACK_PAAQ,
	ANCILLARY_PRODUCT_PACK_PAAR,
	ANCILLARY_PRODUCT_PACK_PBAT,
	ANCILLARY_PRODUCT_PACK_PBAA,
	ANCILLARY_PRODUCT_PACK_PBAB
]


// ancillary ssr codes
export const SSR_CODE_WHEELCHAIR_CARRY = 'WCHC';
export const SSR_CODE_WHEELCHAIR_RAMP = 'WCHR';
export const SSR_CODE_WHEELCHAIR_STEPS = 'WCHS';
export const SSR_CODE_WHEELCHAIR_MANUAL_POWER = 'WCMP';
export const SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY = 'WCBD';
export const SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY = 'WCBW';
export const SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY = 'WCLB';
export const SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL = 'SVAN';
export const SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE = 'BLND';
export const SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE = 'DEAF';
export const SSR_CODE_LUGGAGE_BABY_BASKET = 'BSCT';
export const SSR_CODE_ANIMAL_IN_HOLD = 'AVIH';
export const SSR_CODE_EMOTIONAL_SUPPORT_KENNEL = 'ESAK';
export const SSR_CODE_PET_IN_CABIN = 'PETC';
export const SSR_CODE_BAGGAGE_ADDITIONAL_BAG = 'XBAG';
export const SSR_CODE_BAGGAGE_FIRST_BAG = 'FBAG';
export const SSR_CODE_BAGGAGE_FIRST_BAG_X2 = 'FBAGx2';
export const SSR_CODE_BAGGAGE_FIRST_BAG_X3 = 'FBAGx3';
export const SSR_CODE_BAGGAGE_32_BAG_X2 = '32BAGx2';
export const SSR_CODE_BAGGAGE_32_BAG_X3 = '32BAGx3';
export const SSR_CODE_BAGGAGE_SECOND_BAG = 'SBAG';
export const SSR_CODE_BAGGAGE_BULKY_BAG = 'BULK';
export const SSR_CODE_BAGGAGE_PRIORITY = 'PBAGG';
export const SSR_CODE_BAGGAGE_PACK = 'PKBG'
export const SSR_CODE_FAST_TRACK = 'FAST';
export const SSR_CODE_LOUNGE_ACCESS_1 = 'LOUG';
export const SSR_CODE_MEAL_HINDU_VEGETARIAN = 'AVML';
export const SSR_CODE_MEAL_BABY = 'BBML';
export const SSR_CODE_MEAL_BLAND = 'BLML';
export const SSR_CODE_MEAL_CHILD = 'CHML';
export const SSR_CODE_MEAL_COLD = 'COML';
export const SSR_CODE_MEAL_SEAFOOD_1 = 'CRML';
export const SSR_CODE_MEAL_DIABETICS = 'DBML';
export const SSR_CODE_MEAL_FRUIT_PLATTER = 'FPML';
export const SSR_CODE_MEAL_FISH = 'FSML';
export const SSR_CODE_MEAL_GLUTEN_FREE = 'GFML';
export const SSR_CODE_MEAL_HINDU = 'HNML';
export const SSR_CODE_MEAL_HOT = 'HOML';
export const SSR_CODE_MEAL_KOSHER = 'KSML';
export const SSR_CODE_MEAL_LOW_CALORIE = 'LCML';
export const SSR_CODE_MEAL_LOW_FAT = 'LFML';
export const SSR_CODE_MEAL_LOW_SALT = 'LSML';
export const SSR_CODE_MEAL_MEAT = 'MEML';
export const SSR_CODE_MEAL_MUSLIM = 'MOML';
export const SSR_CODE_MEAL_LACTOSE_FREE = 'NLML';
export const SSR_CODE_MEAL_POULTRY = 'POML';
export const SSR_CODE_MEAL_PASTA = 'PTML';
export const SSR_CODE_MEAL_MEALS_AND_BEVERAGES = 'MEALS';
export const SSR_CODE_SEAFOOD_2 = 'SFML';
export const SSR_CODE_MEAL_SPECIAL = 'SPML';
export const SSR_CODE_MEAL_VEGETARIAN = 'VGML';
export const SSR_CODE_MEAL_VEGETATIAN_LACTO = 'VLML';
export const SSR_CODE_MEAL_SKIP = 'ZZML';
export const SSR_CODE_MUSIC_INSTRUMENT_LARGE = 'MUSL';
export const SSR_CODE_MUSIC_INSTRUMENT_MEDIUM = 'MUSM';
export const SSR_CODE_MUSIC_INSTRUMENT_SMALL = 'MUSS';
export const SSR_CODE_SPORTS_EQUIPMENT_BIKE = 'BIKE';
export const SSR_CODE_SPORTS_EQUIPMENT_FISH = 'FISH';
export const SSR_CODE_SPORTS_EQUIPMENT_GOLF = 'GOLF';
export const SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER = 'HGLI';
export const SSR_CODE_SPORTS_EQUIPMENT_KITE = 'KITE';
export const SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER = 'PGLI';
export const SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT = 'PVLT';
export const SSR_CODE_SPORTS_EQUIPMENT_SCUBA = 'SCUB';
export const SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD = 'SKIM';
export const SSR_CODE_SPORTS_EQUIPMENT_SKI = 'SKIS';
export const SSR_CODE_SPORTS_SPORTING_EQUIPMENT = 'SPEQ';
export const SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD = 'LONG';
export const SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD = 'SURF';
export const SSR_CODE_SPORTS_EQUIPMENT_WINDSURF = 'WIND';
export const SSR_CODE_SEAT_BULKY_ITEMS = 'CBBG';
export const SSR_CODE_SEAT_BABY_SEAT = 'CHDS';
export const SSR_CODE_SEAT_EXTRA = 'EXST';
export const SSR_CODE_SEAT_RESERVATION_1 = 'RQST';
export const SSR_CODE_SEAT_RESERVATION_2 = 'NSST';
export const SSR_CODE_FIREARMS = 'WEAP';
export const SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL = 'ESAN';
export const SSR_CODE_MEDICAL_ASSISTANCE = 'MEDA';
export const SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER = 'STCR';
export const SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN = 'AOXY';
export const SSR_CODE_UNACCOMPANIED_MINOR = 'UMNR';
export const SSR_CODE_MEAL_SNACK = 'SNACK';
export const SSR_CODE_KIOSK = 'KIOSK';
export const SSR_CODE_KIOSK_X2 = 'KIOSKx2';
export const SSR_CODE_KIOSK_X3 = 'KIOSKx3';
export const SSR_CODE_KIOSK_X7 = 'KIOSKx7';
export const SSR_CODE_HAND_BAGGAGE = 'HANDB';
export const SSR_CODE_HAND_BAGGAGE_10 = 'HANDB10';
export const SSR_CODE_HAND_BAGGAGE_X2 = 'HANDBx2';
export const SSR_CODE_HAND_BAGGAGE_10x2 = 'HANDB10x2';
export const SSR_CODE_STANDARD_SEAT_RESERVATION = 'SSEAT';
export const SSR_CODE_PREMIUM_BOARDING = 'PBOARD';
export const SSR_CODE_PRIORITY_CHECK_IN = 'PCHECK';
export const SSR_CODE_LOUNGE_ACCESS_2 = 'LOUNGE';
export const SSR_CODE_PREMIUM_CUSTOMER_CENTER = 'PCENTER';
export const SSR_CODE_FREE_SEAT_RESERVATION = 'PSEAT';
export const SSR_CODE_SEAT = 'SEAT';
export const SSR_CODE_PERSONAL_ITEM = 'PITEM';
export const SSR_CODE_PREFERED_ZONE_SEAT = 'XSEAT';
export const SSR_CODE_MILES_UPGRADE = 'MILESUP';
export const SSR_CODE_PARKING_CAR = 'CPARK';
export const SSR_CODE_PARKING_VALET = 'VPARK';
export const SSR_CODE_SEAT_FREE_ADJACENT = 'FASEAT';
export const SSR_CODE_PLUSGRADE = 'UPGP';
export const SSR_CODE_INFANT = 'INFT';
export const SSR_CODE_FREQUENT_TRAVELLER = 'FQTV';
export const SSR_CODE_FREQUENT_TRAVELLER_MILES_PROGRAM_REDEMPTION = 'FQTR';
export const SSR_CODE_DEPORTEES_1 = 'DEPA';
export const SSR_CODE_DEPORTEES_2 = 'DEPU';
export const SSR_CODE_INADMISSIBLE = 'INAD';
export const SSR_CODE_RECLUSE = 'RECL';
export const SSR_CODE_UM_EXTRA_ASSISTANT = 'ESHO';
export const SSR_CODE_CHANGES = 'CHANGES';
export const SSR_CODE_REFUNDS = 'REFUNDS';
export const SSR_DESCRIPTION_CODE_CHANGES = 'DESCCHANGE';
export const SSR_DESCRIPTION_CODE_REFUNDS = 'DESCREFUND';
export const SSR_CODE_MILES = 'MILES';
export const SSR_CODE_XTFLIGHT = 'XT_FLIGHTS0-3999';
export const SSR_CODE_PREF_BOARD = 'PBRD';


export const SSR_CODE_STAFF = 'STFD';


// ssr codes to be ignored on what's included.
export const SSR_CODES_IGNORE_LIST = [SSR_CODE_MILES_UPGRADE,
	SSR_CODE_PARKING_CAR,
	SSR_CODE_PARKING_VALET,
	SSR_CODE_SEAT_FREE_ADJACENT,
	SSR_CODE_PLUSGRADE,
	SSR_CODE_INFANT,
	SSR_CODE_FREQUENT_TRAVELLER,
	SSR_CODE_FREQUENT_TRAVELLER_MILES_PROGRAM_REDEMPTION,
	'TINS',
	'TTTK',
	'VCHR',
	SSR_CODE_DEPORTEES_1,
	SSR_CODE_DEPORTEES_2,
	SSR_CODE_RECLUSE,
	SSR_CODE_INADMISSIBLE,
	'AMBU',
	SSR_CODE_UM_EXTRA_ASSISTANT,
	SSR_DESCRIPTION_CODE_CHANGES,
	SSR_DESCRIPTION_CODE_REFUNDS,
	SSR_CODE_STAFF,
	SSR_CODE_XTFLIGHT
];

// ssr codes to be ignored on catalog ancillaries.
export const SSR_CODES_CATALOG_EXCLUDED_LIST = [
	SSR_CODE_SEAT_BABY_SEAT,
	SSR_CODE_FIREARMS,
	SSR_CODE_SPORTS_SPORTING_EQUIPMENT,
	SSR_CODE_ANIMAL_IN_HOLD,
	SSR_CODE_EMOTIONAL_SUPPORT_KENNEL
];

// Translation
export const TRANSLATION_ANCILLARIES_TYPE = 'ancillaries.type.';
export const TRANSLATION_ANCILLARY_GROUP = 'ancillaries.group.';
export const TRANSLATION_ANCILLARY_DETAILED = 'ancillaries.detailed.';
export const TRANSLATION_ANCILLARY_PREORDER = 'ancillaries.preorder.';
export const TRANSLATION_ANCILLARY_TEXTS = 'texts.';
export const TRANSLATION_ANCILLARY_TITLE = 'titles.';
export const TRANSLATION_ANCILLARY_SUBTITLE = 'subtitles.';
export const TRANSLATION_ANCILLARY_LABEL = 'label.';
export const TRANSLATION_ANCILLARY_ARIA_LABEL = 'aria.';
export const TRANSLATION_ADD_MORE_MODULE = 'addMoreSidebars.';
export const TRANSLATION_HEADER_MODULE = 'header';
export const TRANSLATION_ALT = 'alt.';
export const TRANSLATION_TEXT = 'text.';
export const TRANSLATION_ARIA = 'aria.';
export const TRANSLATION_BOOKING_DETAILS_MODULE = 'bookingDetails.';
export const TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.';
export const TRANSLATION_SIDEBAR = 'sidebars.';
export const TRANSLATION_DETAILS = 'details.';
export const TRANSLATION_SMALL_PETS = TRANSLATION_ADD_MORE_MODULE + 'smallPets.';
export const TRANSLATION_SPORTS_EQUIPMENT = TRANSLATION_ADD_MORE_MODULE + 'sportsEquipment.';
export const TRANSLATION_FASTTRACK = TRANSLATION_ADD_MORE_MODULE + 'fasttrack.';
export const TRANSLATION_LOUNGE = TRANSLATION_ADD_MORE_MODULE + 'lounge.';
export const TRANSLATION_SPECIAL_MEALS = TRANSLATION_ADD_MORE_MODULE + 'specialMeals.';
export const TRANSLATION_EXTRA_BAGS = TRANSLATION_ADD_MORE_MODULE + 'extraBags.';
export const TRANSLATION_EXTRA_MUSICAL = TRANSLATION_ADD_MORE_MODULE + 'musicInstruments.';
export const TRANSLATION_PREF_BOARD = TRANSLATION_ADD_MORE_MODULE + 'prefBoard.';
export const TRANSLATION_PACK = TRANSLATION_ADD_MORE_MODULE + 'pack.';

// CHUBB INSURANCE TRANSLATION
export const TRANSLATION_INSURANCE = {
	MODULE: 'insurance',
	PROVIDER: 'chubb',
	COVERAGE: 'coverage',
	PLAN: 'plan'
};

// FOPs TRANSLATION
export const TRANSLATION_FOPS = {
	MODULE: 'FOP',
	KEY1: 'tooltip',
	KEY2: 'text',
	LABEL_KEY: 'label'
};


// Extras constants
export const EXTRAS_ANCILLARY_SEAT = 'SEAT';
export const EXTRAS_ANCILLARY_SEAT_SSR = 'RQST';
export const EXTRAS_ANCILLARY_BAG = 'BAG';
export const EXTRAS_ANCILLARY_EQUIPMENT = 'EQUIPMENT';
export const EXTRAS_ANCILLARY_MEAL = 'MEAL';
export const EXTRAS_ANCILLARY_INSURANCE = 'INSURANCE';
export const EXTRAS_ANCILLARY_HOTEL = 'HOTEL';
export const EXTRAS_ANCILLARY_CAR = 'CAR';
export const EXTRAS_ANCILLARY_ANIMAL = 'PET';
export const EXTRAS_ANCILLARY_FAST_TRACK = 'FASTTRACK';
export const EXTRAS_ANCILLARY_LOUNGE = 'LOUNGE';
export const EXTRAS_ANCILLARY_MUSICAL = 'MUSICAL';
export const EXTRAS_ANCILLARY_PREORDER_MEALS = 'PREORDERMEALS';
export const EXTRAS_ANCILLARY_TOURS = 'TOURS_ACTIVITIES';
export const EXTRAS_ANCILLARY_PERSONAL_ASSISTANCE = 'PERSONAL_ASSISTANCE';
export const EXTRAS_ANCILLARY_PARKING = 'PARKING';
export const EXTRAS_ANCILLARY_CARBON_OFFSET = 'CARBON_OFFSET';
export const EXTRAS_ANCILLARY_GUARANTEE_FUND = 'GUARANTEE_FUND';
export const EXTRAS_ANCILLARY_BOOKING_HOTEL = 'BOOKING';
export const EXTRAS_ANCILLARY_PLUSGRADE = 'PLUSGRADE';
export const EXTRAS_ANCILLARY_PREF_BOARD = 'PREFERRED_BOARDING';
export const EXTRAS_ANCILLARY_PACK = 'PACK';
export const EXTRAS_ANCILLARY_PACK_PAAG = 'PAAG';
export const EXTRAS_ANCILLARY_PACK_PAAD = 'PAAD';
export const EXTRAS_ANCILLARY_PACK_PAAE = 'PAAE';
export const EXTRAS_ANCILLARY_PACK_PAAF = 'PAAF';
export const EXTRAS_ANCILLARY_PACK_PAAC = 'PAAC';
export const EXTRAS_ANCILLARY_PACK_PAAH = 'PAAH';
export const EXTRAS_ANCILLARY_PACK_PAAO = 'PAAO';
export const EXTRAS_ANCILLARY_PACK_PAAT = 'PAAT';
export const EXTRAS_ANCILLARY_PACK_PAAB = 'PAAB';
export const EXTRAS_ANCILLARY_PACK_PAAA = 'PAAA';
export const EXTRAS_ANCILLARY_PACK_PAAI = 'PAAI';
export const EXTRAS_ANCILLARY_PACK_PAAQ = 'PAAQ';
export const EXTRAS_ANCILLARY_PACK_PAAR = 'PAAR';
export const EXTRAS_ANCILLARY_PACK_PBAT = 'PBAT';
export const EXTRAS_ANCILLARY_PACK_PBAA = 'PBAA';
export const EXTRAS_ANCILLARY_PACK_PBAB = 'PBAB';

// Multi-segment ancillary sidebar
export const EMD_TYPEC_ANCILLARIES = [
  EXTRAS_ANCILLARY_PREF_BOARD,
  EXTRAS_ANCILLARY_LOUNGE,
  EXTRAS_ANCILLARY_FAST_TRACK
];

// Stopover Extras
export const EXTRAS_ANCILLARY_STOPOVER_HOTEL = 'SO_HOTEL';
export const EXTRAS_ANCILLARY_STOPOVER_LISBOA_CARD = 'SO_LISBON_DISCOUNT';
export const EXTRAS_ANCILLARY_STOPOVER_SIGHTSEEING_TOURS = 'SO_SIGHTSEEING_TOUR';
export const EXTRAS_ANCILLARY_STOPOVER_AIRPORT_TRANSFERS = 'SO_AIRPORT_TRANSFER';

// brand codes
export const BRAND_CODE_DISCOUNT = 'discount';
export const BRAND_CODE_CLASSIC = 'classic';
export const BRAND_CODE_PLUS = 'plus';
export const BRAND_CODE_EXECUTIVE = 'executive';
export const BRAND_CODE_BASIC = 'basic';
export const BRAND_CODE_TOP_EXECUTIVE = 'top-executive';
export const BRAND_CODE_AWARD_ECONOMY = 'miles&go-economy';
export const BRAND_CODE_AWARD_EXECUTIVE = 'miles&go-executive';
export const BRAND_CODE_AWARD_EXTRA = 'miles&go-extra';
export const BRAND_CODE_STAR_ALLIANCE_ECONOMY = 'star_alliance-economy';
export const BRAND_CODE_STAR_ALLIANCE_BUSINESS = 'star_alliance-business';
export const BRAND_CODE_STAR_ALLIANCE_FIRST = 'star_alliance-first';

// star alliance brands
export const BRAND_CODE_STAR_ALLIANCE = [BRAND_CODE_STAR_ALLIANCE_ECONOMY, BRAND_CODE_STAR_ALLIANCE_BUSINESS, BRAND_CODE_STAR_ALLIANCE_FIRST];

// brand seats
export const EXECUTIVE_SEATS = 'Executive seats';
export const BUSINESS_SEATS = 'Business seats';
export const ECONOMY_SEATS = 'Economy seats';


// brand descriptions
export const BRAND_DESCRIPTION_DISCOUNT = 'Discount';
export const BRAND_DESCRIPTION_CLASSIC = 'Classic';
export const BRAND_DESCRIPTION_PLUS = 'Plus';
export const BRAND_DESCRIPTION_EXECUTIVE = 'Executive';
export const BRAND_DESCRIPTION_BASIC = 'Basic';
export const BRAND_DESCRIPTION_TOP_EXECUTIVE = 'Top Executive';

// ancillary group
export const ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE = 'LOUNGE';
export const ANCILLARY_PRODUCT_GROUP_CODE_MEAL = 'MEAL';
export const ANCILLARY_PRODUCT_GROUP_CODE_SNACK = 'SNACK';
export const ANCILLARY_PRODUCT_GROUP_CODE_WHEELCHAIR = 'WHEELCHAIR';
export const ANCILLARY_PRODUCT_GROUP_CODE_SERVICE_ANIMAL = 'SERVICE_ANIMAL';
export const ANCILLARY_PRODUCT_GROUP_CODE_BLIND_ASSISTANCE = 'BLIND_ASSISTANCE';
export const ANCILLARY_PRODUCT_GROUP_CODE_DEAF_ASSISTANCE = 'DEAF_ASSISTANCE';
export const ANCILLARY_PRODUCT_GROUP_CODE_LUGGAGE_BABY_BASKET = 'LUGGAGE_BABY_BASKET';
export const ANCILLARY_PRODUCT_GROUP_CODE_ANIMAL_IN_HOLD = 'ANIMAL_IN_HOLD';
export const ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN = 'PET_IN_CABIN';
export const ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE = 'HOLD_BAGGAGE';
export const ANCILLARY_PRODUCT_GROUP_CODE_BULKY_BAGGAGE = 'BULKY_BAGGAGE';
export const ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK = 'FASTTRACK';
export const ANCILLARY_PRODUCT_GROUP_CODE_MUSIC_INSTRUMENT = 'MUSIC_INSTRUMENT';
export const ANCILLARY_PRODUCT_GROUP_CODE_SPORTS_EQUIPMENT = 'SPORTS_EQUIPMENT';
export const ANCILLARY_PRODUCT_GROUP_CODE_EXTRA_SEAT = 'EXTRA_SEAT';
export const ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION = 'SEAT_RESERVATION';
export const ANCILLARY_PRODUCT_GROUP_CODE_WEAPON = 'WEAPON';
export const ANCILLARY_PRODUCT_GROUP_CODE_MEDICAL_ASSISTANCE = 'MEDICAL_ASSISTANCE';
export const ANCILLARY_PRODUCT_GROUP_CODE_UNACCOMPANIED_MINOR = 'UNACCOMPANIED_MINOR';
export const ANCILLARY_PRODUCT_GROUP_CODE_KIOSK = 'KIOSK';
export const ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE = 'HAND_BAGGAGE';
export const ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_BOARDING = 'PREMIUM_BOARDING';
export const ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN = 'PRIORITY_CHECK_IN';
export const ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_CUSTOMER_CENTER = 'PREMIUM_CUSTOMER_CENTER';
export const ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_BAGGAGE = 'PRIORITY_BAGGAGE';
export const ANCILLARY_PRODUCT_GROUP_CODE_MILES = 'MILES';
export const ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD = 'PREFERRED_BOARDING';

// ancillary group's list
export const ANCILLARY_GROUP_PREMIUM_CUSTOMER_CENTER_LIST = [SSR_CODE_PREMIUM_CUSTOMER_CENTER];
export const ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST = [SSR_CODE_PRIORITY_CHECK_IN];
export const ANCILLARY_GROUP_PREMIUM_BOARDING_LIST = [SSR_CODE_PREMIUM_BOARDING];
export const ANCILLARY_GROUP_HAND_BAGGAGE_LIST = [SSR_CODE_HAND_BAGGAGE,
	SSR_CODE_HAND_BAGGAGE_10,
	SSR_CODE_HAND_BAGGAGE_X2,
	SSR_CODE_HAND_BAGGAGE_10x2,
	SSR_CODE_PERSONAL_ITEM];
export const ANCILLARY_GROUP_KIOSK_LIST = [SSR_CODE_KIOSK,
	SSR_CODE_KIOSK_X2,
	SSR_CODE_KIOSK_X3,
	SSR_CODE_KIOSK_X7];
export const ANCILLARY_GROUP_UNACCOMPANIED_MINOR_LIST = [SSR_CODE_UNACCOMPANIED_MINOR];
export const ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST = [SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
	SSR_CODE_MEDICAL_ASSISTANCE,
	SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
	SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN];
export const ANCILLARY_GROUP_WEAPON_LIST = [SSR_CODE_FIREARMS];
export const ANCILLARY_GROUP_SEAT_RESERVATION_LIST = [SSR_CODE_SEAT_RESERVATION_1,
	SSR_CODE_SEAT_RESERVATION_2,
	SSR_CODE_STANDARD_SEAT_RESERVATION,
	SSR_CODE_FREE_SEAT_RESERVATION,
	SSR_CODE_SEAT,
	SSR_CODE_PREFERED_ZONE_SEAT];
export const ANCILLARY_GROUP_EXTRA_SEAT_LIST = [SSR_CODE_SEAT_BULKY_ITEMS,
	SSR_CODE_SEAT_BABY_SEAT,
	SSR_CODE_SEAT_EXTRA];
export const ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST = [SSR_CODE_SPORTS_EQUIPMENT_BIKE,
	SSR_CODE_SPORTS_EQUIPMENT_FISH,
	SSR_CODE_SPORTS_EQUIPMENT_GOLF,
	SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER,
	SSR_CODE_SPORTS_EQUIPMENT_KITE,
	SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER,
	SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT,
	SSR_CODE_SPORTS_EQUIPMENT_SCUBA,
	SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_SKI,
	SSR_CODE_SPORTS_SPORTING_EQUIPMENT,
	SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_WINDSURF];
export const ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST = [SSR_CODE_MUSIC_INSTRUMENT_SMALL,
	SSR_CODE_MUSIC_INSTRUMENT_MEDIUM,
	SSR_CODE_MUSIC_INSTRUMENT_LARGE];
export const ANCILLARY_GROUP_FAST_TRACK_LIST = [SSR_CODE_FAST_TRACK];
export const ANCILLARY_GROUP_BULKY_BAGGAGE_LIST = [SSR_CODE_BAGGAGE_BULKY_BAG];
export const ANCILLARY_GROUP_HOLD_BAGGAGE_LIST = [SSR_CODE_BAGGAGE_FIRST_BAG,
	SSR_CODE_BAGGAGE_SECOND_BAG,
	SSR_CODE_BAGGAGE_ADDITIONAL_BAG,
	SSR_CODE_BAGGAGE_FIRST_BAG_X2,
	SSR_CODE_BAGGAGE_FIRST_BAG_X3,
	SSR_CODE_BAGGAGE_32_BAG_X2,
	SSR_CODE_BAGGAGE_32_BAG_X3];
export const ANCILLARY_GROUP_PRIORITY_BAGGAGE_LIST = [SSR_CODE_BAGGAGE_PRIORITY];
export const ANCILLARY_GROUP_PET_IN_CABIN_LIST = [SSR_CODE_PET_IN_CABIN];
export const ANCILLARY_GROUP_ANIMAL_IN_HOLD_LIST = [SSR_CODE_ANIMAL_IN_HOLD];
export const ANCILLARY_GROUP_LUGGAGE_BABY_BASKET_LIST = [SSR_CODE_LUGGAGE_BABY_BASKET];
export const ANCILLARY_GROUP_BLIND_ASSISTANCE_LIST = [SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE];
export const ANCILLARY_GROUP_DEAF_ASSISTANCE_LIST = [SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE];
export const ANCILLARY_GROUP_SERVICE_ANIMAL_LIST = [SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL];
export const ANCILLARY_GROUP_WHEELCHAIR_LIST = [SSR_CODE_WHEELCHAIR_CARRY,
	SSR_CODE_WHEELCHAIR_RAMP,
	SSR_CODE_WHEELCHAIR_STEPS,
	SSR_CODE_WHEELCHAIR_MANUAL_POWER,
	SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY,
	SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY,
	SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY];
export const ANCILLARY_GROUP_LOUNGE_LIST = [SSR_CODE_LOUNGE_ACCESS_1,
	SSR_CODE_LOUNGE_ACCESS_2];
export const ANCILLARY_GROUP_MEAL_LIST = [SSR_CODE_MEAL_HINDU_VEGETARIAN,
	SSR_CODE_MEAL_BABY,
	SSR_CODE_MEAL_BLAND,
	SSR_CODE_MEAL_CHILD,
	SSR_CODE_MEAL_COLD,
	SSR_CODE_MEAL_SEAFOOD_1,
	SSR_CODE_MEAL_DIABETICS,
	SSR_CODE_MEAL_FRUIT_PLATTER,
	SSR_CODE_MEAL_FISH,
	SSR_CODE_MEAL_GLUTEN_FREE,
	SSR_CODE_MEAL_HINDU,
	SSR_CODE_MEAL_HOT,
	SSR_CODE_MEAL_KOSHER,
	SSR_CODE_MEAL_LOW_CALORIE,
	SSR_CODE_MEAL_LOW_FAT,
	SSR_CODE_MEAL_LOW_SALT,
	SSR_CODE_MEAL_MEAT,
	SSR_CODE_MEAL_MUSLIM,
	SSR_CODE_MEAL_LACTOSE_FREE,
	SSR_CODE_MEAL_POULTRY,
	SSR_CODE_MEAL_PASTA,
	SSR_CODE_SEAFOOD_2,
	SSR_CODE_MEAL_SPECIAL,
	SSR_CODE_MEAL_VEGETARIAN,
	SSR_CODE_MEAL_VEGETATIAN_LACTO,
	SSR_CODE_MEAL_SNACK,
	SSR_CODE_MEAL_MEALS_AND_BEVERAGES];
export const ANCILLARY_GROUP_DEPORTEES_LIST = [SSR_CODE_DEPORTEES_1,
	SSR_CODE_DEPORTEES_2,
	SSR_CODE_INADMISSIBLE,
	SSR_CODE_RECLUSE];
export const ANCILLARY_GROUP_MILES_LIST = [SSR_CODE_MILES];
export const ANCILLARY_GROUP_PREF_BOARDING_LIST = [SSR_CODE_PREF_BOARD];

// DOCUMENT TYPE NUMBER
export const DOCUMENT_NUMBER_PASSPORT = '21';
export const DOCUMENT_NUMBER_NATIONAL_IDENTITY_CARD = '5';
export const DOCUMENTS_NUMBER_PASSPORT = ['21', '2'];


// LISBON CODE
export const LISBON_CODE = 'LIS';
export const UK_COUNTRY_CODE = 'GB';

// TAP EXPRESS
export const TP_EXPRESS_PORTUGALIA = 'NI';
export const TP_EXPRESS_WHITE_AIRWAYS = 'WI';

// TAP EXPRESS LOGO
export const TP_EXPRESS_LOGO = [TP_EXPRESS_PORTUGALIA, TP_EXPRESS_WHITE_AIRWAYS];

// TAP codeshare/interline flights
export const CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER = [TP_EXPRESS_PORTUGALIA, TP_EXPRESS_WHITE_AIRWAYS, AIR_LINE_CODE_TAP];

// Translation key for infant's checked baggage weight limit
export const CHECKED_BAGGAGE_FOR_INFANT_TRANSLATION_KEY = 'INFBAG';

export const CHECKED_BAGGAGE_ANCILLARY_CODES = [
	'XBAG',
	'FBAG',
	'SBAG',
	'FBAGx2',
	'FBAGx3',
	'32BAGx2',
	'32BAGx3'
];

// STATUS CODES
export const CANCELLED_CODES = [21, 6, 41, 16];
export const UNCONFIRMED_CODES = [41, 22, 46];

// hide this if codeshare
export const CODESHARE_HIDDEN_ANCILLARIES = [EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_MUSICAL];

// disable change flight and update flight if these ancillaries are present
export const ANCILLARIES_INELIGIBLE_FOR_CHANGE = [
	SSR_CODE_BAGGAGE_BULKY_BAG,
	SSR_CODE_SEAT_BULKY_ITEMS,
	SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE,
	SSR_CODE_DEPORTEES_1,
	SSR_CODE_DEPORTEES_2,
	SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
	SSR_CODE_UM_EXTRA_ASSISTANT,
	SSR_CODE_SEAT_EXTRA,
	SSR_CODE_INADMISSIBLE,
	SSR_CODE_MEDICAL_ASSISTANCE,
	SSR_CODE_RECLUSE,
	SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
	SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL,
	SSR_CODE_UNACCOMPANIED_MINOR,
	SSR_CODE_WHEELCHAIR_CARRY,
	SSR_CODE_WHEELCHAIR_RAMP,
	SSR_CODE_WHEELCHAIR_STEPS,
	SSR_CODE_FIREARMS,
	SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN,
	SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE,
	SSR_CODE_ANIMAL_IN_HOLD
];

export const MUSICAL_INSTRUMENT_ORDER = [SSR_CODE_MUSIC_INSTRUMENT_SMALL, SSR_CODE_MUSIC_INSTRUMENT_MEDIUM, SSR_CODE_MUSIC_INSTRUMENT_LARGE];
export const ANCILLARY_FOR_FIRST_SEGMENT = [EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_LOUNGE];
export const AWARD_RBD_LIST = ['X'];

export const TIER_ECONOMY_BAGGAGE = 'ECOBAGTIER';
export const TIER_BUSINESS_BAGGAGE = 'BUSBAGTIER';

export const EQUIPMENT_CODE_BUS = 'BUS';
export const EQUIPMENT_CODE_TRAIN = 'TRN';

export const AIRPLANE_EQUIPMENT_CODE_319 = '319';
export const AIRPLANE_EQUIPMENT_CODE_320 = '320';
export const AIRPLANE_EQUIPMENT_CODE_321 = '321';
export const AIRPLANE_EQUIPMENT_CODE_332 = '332';
export const AIRPLANE_EQUIPMENT_CODE_343 = '343';
export const AIRPLANE_EQUIPMENT_CODE_AT7 = 'AT7';
export const AIRPLANE_EQUIPMENT_CODE_E90 = 'E90';
export const AIRPLANE_EQUIPMENT_CODE_E95 = 'E95';
export const AIRPLANE_EQUIPMENT_CODE_32N = '32N';
export const AIRPLANE_EQUIPMENT_CODE_32Q = '32Q';
export const AIRPLANE_EQUIPMENT_CODE_339 = '339';

export const AIRPLANE_EQUIPMENT_WITH_LOGOS = [AIRPLANE_EQUIPMENT_CODE_32N, AIRPLANE_EQUIPMENT_CODE_32Q, AIRPLANE_EQUIPMENT_CODE_339];

export const AIRPLANE_EQUIPMENT_MODEL_319 = 'A319';
export const AIRPLANE_EQUIPMENT_MODEL_320 = 'A320';
export const AIRPLANE_EQUIPMENT_MODEL_321 = 'A321';
export const AIRPLANE_EQUIPMENT_MODEL_332 = 'A330-200';
export const AIRPLANE_EQUIPMENT_MODEL_343 = 'A340';
export const AIRPLANE_EQUIPMENT_MODEL_AT7 = 'ATR72';
export const AIRPLANE_EQUIPMENT_MODEL_E90 = 'Embraer-190';
export const AIRPLANE_EQUIPMENT_MODEL_E95 = 'Embraer-195';
export const AIRPLANE_EQUIPMENT_MODEL_32N = 'A320neo';
export const AIRPLANE_EQUIPMENT_MODEL_32Q = 'A321LR';
export const AIRPLANE_EQUIPMENT_MODEL_339 = 'A330neo';

export const SEATMAP_AIRBUS_A319_100_CODE = '319';
export const SEATMAP_AIRBUS_A320_200_CODE = '320';
export const SEATMAP_AIRBUS_A321_200_CODE = '321';
export const SEATMAP_AIRBUS_A330_200_RETROFIT_CODE = '332';
export const SEATMAP_AIRBUS_A340_300_CODE = '343';
export const SEATMAP_AIRBUS_ATR_72_600_CODE = 'AT7';
export const SEATMAP_EMBRAER_190_CODE = 'E90';
export const SEATMAP_EMBRAER_195_CODE = 'E95';
export const SEATMAP_AIRBUS_A320_NEO_CODE = '32N';
export const SEATMAP_AIRBUS_A321_NEO_CODE = '32Q';
export const SEATMAP_AIRBUS_A330_NEO_CODE = '339';

export const SEATMAP_SEAT_TYPE_STANDARD = 'standard';
export const SEATMAP_SEAT_TYPE_PREFERED = 'preferred';
export const SEATMAP_SEAT_TYPE_BUSINESS = 'business';

export const SEATMAP_EQUIPMENT_FOLDER_A319_A320_A321 = 'A319, A320, A321';
export const SEATMAP_EQUIPMENT_FOLDER_A321_LR = 'A321 LR';
export const SEATMAP_EQUIPMENT_FOLDER_A321_NEO = 'A321 NEO';
export const SEATMAP_EQUIPMENT_FOLDER_A332 = 'A330-200-retrofit';
export const SEATMAP_EQUIPMENT_FOLDER_A330_NEO = 'A330-NEO';
export const SEATMAP_EQUIPMENT_FOLDER_A340 = 'A340';
export const SEATMAP_EQUIPMENT_FOLDER_ATR = 'ATR';
export const SEATMAP_EQUIPMENT_FOLDER_EMBRAER = 'Embraer';

export const SEATMAP_SEAT_TYPE_FOLDER_GENERAL = '00_Plano-Geral';
export const SEATMAP_SEAT_TYPE_FOLDER_STANDARD = '01_Economy';
export const SEATMAP_SEAT_TYPE_FOLDER_PREFERED = '02_Economy-Extra';
export const SEATMAP_SEAT_TYPE_FOLDER_EXECUTIVE = '03_Executive';
export const SEATMAP_SEAT_TYPE_FOLDER_BUSINESS = '03_Business';

export const SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT = './assets/images/ancillaries/seats';
export const SEATMAP_SEAT_IMAGE_PATH_INTERIORES_195 = '02_Interiores/195';

export const TRANSLATION_MODULES_BOOKING_DETAILS_PAGE = ['bookingDetails', 'ancillaries', 'addMoreSidebars', 'whatsIncludedSidebars', 'bookingsList', 'shoppingBasket', 'changeFlight', 'cancelBooking', 'fareconditions', 'Search', 'bookingSearch', 'checkin', 'editSidebar', 'myTrips', 'flightStatus', 'modals', 'availability', 'voucherPromocodeSidebar', 'priceBreakdown', 'tripExtras', 'economyExtraSidebar', 'bookingView'];
export const TRANSLATION_MODULES_BOOKING_FLIGHTS_PAGE = ['ancillaries', 'busStops', 'priceBreakdown', 'availability'];
// Seat Features
export const SEATMAP_FLATBED = 'addMoreSidebars.seatmap.text.flatBed';
export const SEATMAP_COMFY_LEGROOM = 'addMoreSidebars.seatmap.text.comfortableLegroom';
export const SEATMAP_ONDEMAND_TV = 'addMoreSidebars.seatmap.text.onDemandTv';

// seat price codes
export const SEAT_PRICE_TICKET_AMOUNT_CODE = '52';
export const SEAT_PRICE_BASE_AMOUNT_CODE = '14';
export const SEAT_PRICE_TAX_AMOUNT_CODE = '17';
export const PNR_LIST_STATUS_ACTIVE = 'Active';
export const PNR_LIST_STATUS_PURGED = 'Purged';

export const AIRPORT_LISBON = 'LIS';
export const AIRPORT_PORTO = 'OPO';
export const AIRPORT_LISBON_STOPTIME_THRESHOLD_DOMESTIC = 45;
export const AIRPORT_LISBON_STOPTIME_THRESHOLD_INTERNATIONAL = 60;
export const AIRPORT_PORTO_STOPTIME_THRESHOLD_DOMESTIC = 30;
export const AIRPORT_PORTO_STOPTIME_THRESHOLD_INTERNATIONAL = 60;
export const DEFAULT_STOPTIME_THRESHOLD = 20;


// backend trip type values (TODO deprecate this AND reuse existing)
export const TRIP_TYPE_ROUND_TRIP = 'R';
export const TRIP_TYPE_ONE_WAY = 'O';
export const TRIP_TYPE_MULTICITY = 'M';
export const DEFAULT_TRIP_TYPE = TRIP_TYPE_ROUND_TRIP;
export const FLIGHT_STATUS_TRIP_TYPE_CODE = 'R';

// request cache
export const MOCK_PATH = './assets/data/';
export const REQUEST_CACHE_AGE = 60000;
export const API_URLS_WITH_REQUEST_CACHE = [
	// uncomment those API URLs you want to include in caching
	/*
	MOCK_PATH ,
	URL_BFM_LOCATION_ORIGIN,
	URL_BFM_LOCATION_DESTINATION,
	URL_BFM_LOCATION_ORIGIN_MULTICITY
	*/
];

export const TRANSLATION_MODULES_SEARCH_PAGE = ['Search', 'bookingSearch', 'checkin', 'myTrips', 'editSidebar', 'flightStatus', 'modals', 'availability', 'bookingDetails', 'ancillaries', 'addMoreSidebars', 'whatsIncludedSidebars', 'fareconditions', 'FOP', 'extrasSidebar', 'dates', 'contextMenu', 'busStops', 'shoppingBasket', 'voucherPromocodeSidebar', 'filterFlightsSidebar', 'priceBreakdown', 'tripExtras', 'review', 'timeToThink', 'cancelBooking', 'economyExtraSidebar', 'bookingView',
	'insurance', 'bookingPayment', 'createAccountSidebar', 'countries'];


// airline IDs (TODO check if there is an existing that can be used; deprecate if not needed anymore)
export const AIRLINE_TAP_CODE = 'TP';
export const DEFAULT_AIRLINE_IDS = [AIRLINE_TAP_CODE];

export const TAP_EXPERIENCE = 'TPEX';

export const MULTICITY_MINIMUM_FLIGHTS = 2;
export const MULTICITY_MAXIMUM_FLIGHTS = 5;

// session storage keys
export const SESSION_VAR_KEY_SESSION = 'token';
export const SESSION_VAR_KEY_MARKET = 'market';
export const SESSION_VAR_KEY_SEARCH_ROUTE = 'SearchRoute';
export const SESSION_VAR_KEY_LANGUAGE = 'language';
export const SESSION_VAR_KEY_PNR = 'pnr';
export const SESSION_VAR_KEY_LASTNAME = 'lastname';
export const SESSION_VAR_KEY_USER_DATA = 'userData';
export const SESSION_VAR_KEY_CURRENCY = 'currency';
export const SESSION_VAR_KEY_BOOK_AWARD_FLIGHTS = 'bookAwardFlights';
export const SESSION_VAR_KEY_PAYMENT_SESSION_ID = 'paymentSessionID';
export const SESSION_VAR_KEY_PASSENGERS = 'passengers';
export const SESSION_VAR_KEY_SEARCH_ROUTE_MULTICITY = 'SearchRouteMulticity';

// availability calendar price api constant param
export const AVAILABILITY_CALENDAR_PARAM_CABIN_CLASS = 'E';

// calendar keys

export const CALENDAR_VAR_KEY_BEST_PRICE = 'bestPriceForDates';
export const CALENDAR_VAR_KEY_RETURNS = 'returns';
export const CALENDAR_VAR_KEY_DEPARTURE_DATE = 'departureDate';
export const CALENDAR_VAR_KEY_RETURN_DATE = 'returnDate';

// codes with discounts

// Madeira Airport Codes
export const AIRPORT_CODES_VAR_KEY_MADEIRA_DISCOUNT = [
	'FNC',
	'PXO'
];

// Azores Airport Codes
export const AIRPORT_CODES_VAR_KEY_AZORES_DISCOUNT = [
	'CVU',
	'GRW',
	'HOR',
	'PDL',
	'PIX',
	'FLW',
	'SMA',
	'TER',
	'SJZ',
];

export const URL_KEYS_WITH_DYNAMIC_LANGUAGE = [
	'Search.allBookingOptions',
	'Search.rentACar',
	'Search.bookATransfer',
	'Search.bookAHotel',
	'Search.parking'
];

export const SPECIAL_CASE_MARKET_LANGUAGE_MAP = {
	'pt-br': 'pt',
	'pt-pt': 'pt',
	'en-us': 'en'
};

export const SPECIAL_CASE_LANGUAGE_MAP = {
	'pt-br': 'br'
};

// brand code grouping to know which are considered economy or business brands
export const ECONOMY_BRANDS = [BRAND_CODE_DISCOUNT, BRAND_CODE_BASIC, BRAND_CODE_CLASSIC, BRAND_CODE_PLUS, BRAND_CODE_AWARD_ECONOMY];
export const BUSINESS_BRANDS = [BRAND_CODE_EXECUTIVE, BRAND_CODE_TOP_EXECUTIVE, BRAND_CODE_AWARD_EXECUTIVE];

// Currency Units
export const CURRENCY_UNITS = {
	EUR: '€',
};

// format date to MMDDYYYY if current language is included in this list
export const SPECIAL_CASE_MMDDYYY_FORMAT = ['en-us', 'en'];
export const SPECIAL_CASE_COUNTRIES_MMDDYYY_FORMAT = ['ca', 'us'];

// do not append market if current language is included in this list
export const SPECIAL_CASE_REDIRECTION = ['en-us', 'pt-br'];

// countries with different ordinal number system
export const SPECIAL_CASE_LANGUAGE_ORDINAL_NUMBERS = ['es', 'pt', 'pt-br']

// Basic Ancillary Codes from Fare Information TAC
export const BASIC_ANCILLARY_CODES_MILES = 'BA_MILES';
export const BASIC_ANCILLARY_CODES_HAND_BAGGAGE = 'BA_HANDB';
export const BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE = 'BA_CKBAG';
export const BASIC_ANCILLARY_CODES_SEAT_RESERVATION = 'BA_SSEAT';
export const BASIC_ANCILLARY_CODES_MEALS = 'BA_MEALS';
export const BASIC_ANCILLARY_CODES_SNACK = 'BA_SNACK';
export const BASIC_ANCILLARY_CODES_PREMIUM_BOARDING = 'BA_PBOARD';
export const BASIC_ANCILLARY_CODES_FASTTRACK = 'BA_FAST';
export const BASIC_ANCILLARY_CODES_FLIGHT_CHANGES = 'BA_CHANGES';
export const BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS = 'BA_REFUNDS';
export const BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN = 'BA_PCHECK';
export const BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER = 'BA_PCENTER';
export const BASIC_ANCILLARY_CODES_LOUNGE = 'BA_LOUNGE'; // note: temporary; no actual code yet for backend

// note: the following codes are dummy and not from backend, for frontend's use only
export const BASIC_ANCILLARY_CODES_FLIGHT_CANCELLATION = 'CANCELLATION';
export const BASIC_ANCILLARY_CODES_KIOSK = 'KIOSK';
export const BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE = 'BA_PBAGG';
export const BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE = 'PREBAGGAGE';


// actual ancillary codes to be expected from the TAC fare information API basic-ancillaries object
export const BASIC_ANCILLARY_CODES = [
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_PREMIUM_BOARDING,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
	BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER,
	BASIC_ANCILLARY_CODES_LOUNGE
];


// Compare Fares - ECONOMY brands matrix features
export const ECONOMY_BRANDS_FEATURE_MATRIX_LIST_1 = [
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS
];
export const ECONOMY_BRANDS_FEATURE_MATRIX_LIST_2 = [
	BASIC_ANCILLARY_CODES_KIOSK,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
	BASIC_ANCILLARY_CODES_PREMIUM_BOARDING,
	BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE,
	BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE,
	BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER
];

// Compare Fares - BUSINESS brands matrix features
export const BUSINESS_BRANDS_FEATURE_MATRIX_LIST_1 = [
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_MILES,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS
];
export const BUSINESS_BRANDS_FEATURE_MATRIX_LIST_2 = [
	BASIC_ANCILLARY_CODES_KIOSK,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
	BASIC_ANCILLARY_CODES_PREMIUM_BOARDING,
	BASIC_ANCILLARY_CODES_PRIORITY_BAGGAGE,
	BASIC_ANCILLARY_CODES_PREMIUM_BAGGAGE,
	BASIC_ANCILLARY_CODES_PREMIUM_CUSTOMER_CENTER
];

// Compare Fares - TAP Award brands matrix features
export const TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_1 = [
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_SEAT_RESERVATION,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS
];
export const TAP_AWARD_BRANDS_FEATURE_MATRIX_LIST_2 = [
	BASIC_ANCILLARY_CODES_KIOSK,
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN,
];

// Compare Fares - Star Alliance Award brands matrix features
export const STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_1 = [
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_HAND_BAGGAGE,
	BASIC_ANCILLARY_CODES_CHECKED_BAGGAGE,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BASIC_ANCILLARY_CODES_FLIGHT_CHANGES,
	BASIC_ANCILLARY_CODES_FLIGHT_REFUNDS
];
export const STAR_ALLIANCE_AWARD_BRANDS_FEATURE_MATRIX_LIST_2 = [
	BASIC_ANCILLARY_CODES_PREMIUM_CHECKIN
];


export const COMMERCIAL_ECONOMY_BRANDS = [
	BRAND_CODE_DISCOUNT,
	BRAND_CODE_BASIC,
	BRAND_CODE_CLASSIC,
	BRAND_CODE_PLUS
];

export const COMMERCIAL_BUSINESS_BRANDS = [
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_TOP_EXECUTIVE
];

export const TAP_AWARD_BRANDS = [
	BRAND_CODE_AWARD_ECONOMY,
	BRAND_CODE_AWARD_EXTRA,
	BRAND_CODE_AWARD_EXECUTIVE
];

export const STAR_ALLIANCE_AWARD_BRANDS = [
	BRAND_CODE_STAR_ALLIANCE_ECONOMY,
	BRAND_CODE_STAR_ALLIANCE_BUSINESS,
	BRAND_CODE_STAR_ALLIANCE_FIRST
];

export const BRAND_NAMES_MAP = {
	[BRAND_CODE_DISCOUNT]: 'Discount',
	[BRAND_CODE_BASIC]: 'Basic',
	[BRAND_CODE_CLASSIC]: 'Classic',
	[BRAND_CODE_PLUS]: 'Plus',
	[BRAND_CODE_EXECUTIVE]: 'Executive',
	[BRAND_CODE_TOP_EXECUTIVE]: 'Top Executive',
	[BRAND_CODE_AWARD_ECONOMY]: 'Economy Miles&Go',
	[BRAND_CODE_AWARD_EXTRA]: 'Extra Miles&Go',
	[BRAND_CODE_AWARD_EXECUTIVE]: 'Executive Miles&Go',
	[BRAND_CODE_STAR_ALLIANCE_ECONOMY]: 'Star Alliance Economy',
	[BRAND_CODE_STAR_ALLIANCE_BUSINESS]: 'Star Alliance Business',
	[BRAND_CODE_STAR_ALLIANCE_FIRST]: 'Star Alliance First',
};

// export const CURRENCIES_SYMBOLS = {
// 	// change currencySymbols of these currencies to these
// 	XOF: { currencySymbol: 'CFA' },
// 	CLP: { currencySymbol: 'CLP' },
// 	COP: { currencySymbol: 'COL$' },
// 	TRY: { currencySymbol: 'TL' },
// 	MXN: { currencySymbol: 'MXN' },
// 	MZN: { currencySymbol: 'MT' },
// 	CAD: { currencySymbol: 'C$' },
// 	// change highlightSymbol of these currencies to $
// 	dollar: {
// 		currencySymbol: '$',
// 		highlightDollar: ['XOF', 'HUF', 'MAD', 'DKK', 'TRY', 'ZAR', 'AOA', 'MZN', 'NOK', 'CZK', 'BRL', 'CLP', 'SEK', 'AUD', 'PLN', 'CAD', 'HRK', 'CHF', 'CFA']
// 	}
// };

export const CURRENCIES_SYMBOLS = {
	// change currencySymbols of these currencies to these
	USD: { currencySymbol: 'USD' },
	EUR: { currencySymbol: 'EUR' },
	CFA: { currencySymbol: 'CFA' },
	COP: { currencySymbol: 'COP' },
	HUF: { currencySymbol: 'HUF' },
	MAD: { currencySymbol: 'MAD' },
	DKK: { currencySymbol: 'DKK' },
	ZAR: { currencySymbol: 'ZAR' },
	AOA: { currencySymbol: 'AOA' },
	GBP: { currencySymbol: 'GBP' },
	MXN: { currencySymbol: 'MXN' },
	RUB: { currencySymbol: 'RUB' },
	NOK: { currencySymbol: 'NOK' },
	CNY: { currencySymbol: 'CNY' },
	CZK: { currencySymbol: 'CZK' },
	BRL: { currencySymbol: 'BRL' },
	CLP: { currencySymbol: 'CLP' },
	SEK: { currencySymbol: 'SEK' },
	AUD: { currencySymbol: 'AUD' },
	PLN: { currencySymbol: 'PLN' },
	HRK: { currencySymbol: 'HRK' },
	CHF: { currencySymbol: 'CHF' },
	TRY: { currencySymbol: 'TRY' },
	MZN: { currencySymbol: 'MZN' },
	CAD: { currencySymbol: 'CAD' },
	XOF: { currencySymbol: 'XOF' },
	// change highlightSymbol of these currencies to $
	dollar: {
		currencySymbol: '$',
		highlightDollar: ['XOF', 'HUF', 'MAD', 'DKK', 'TRY', 'ZAR', 'AOA', 'MZN', 'NOK', 'CZK', 'BRL', 'CLP', 'SEK', 'AUD', 'PLN', 'CAD', 'HRK', 'CHF', 'CFA']
	}
};

export const ALL_CABIN_CODE = 'E';
export const ECONOMY_CABIN_CODE = 'Y';
export const EXECUTIVE_CABIN_CODE = 'C';
export const FIRST_CLASS_CABIN_CODE = 'staralliance';
export const TAP_COMMERCIAL_BUSINESS_CABIN_RBD_LIST = ['C', 'Z', 'I', 'J'];
export const TAP_AWARD_BUSINESS_CABIN_RBD_LIST = ['I', 'Z'];
export const STAR_AWARD_BUSINESS_CABIN_RBD_LIST = ['I'];

export const AIRLINE_CODES = ['0B', '0O', '2K', '9U', '9W', 'A3', 'AA', 'AC', 'AD', 'AF', 'AH', 'AI', 'AM', 'AR', 'AT', 'AV',
	'AW', 'AY', 'AZ', 'B6', 'BA', 'BE', 'BR', 'BT', 'CA', 'CI', 'CM', 'CX', 'CZ', 'DL', 'DT', 'EK', 'ET', 'EY', 'FB', 'FI', 'FM',
	'G3', 'GF', 'HU', 'HX', 'IB', 'IG', 'JD', 'JL', 'JP', 'JU', 'KE', 'KL', 'KM', 'KP', 'LG', 'LH', 'LO', 'LR', 'LX', 'LY', 'MH',
	'MK', 'MS', 'MU', 'NH', 'NT', 'NZ', 'O6', 'OA', 'OK', 'OS', 'OU', 'OZ', 'PS', 'QF', 'QR', 'RJ', 'RO', 'S4', 'S7', 'SA', 'SK',
	'SN', 'SP', 'SQ', 'SU', 'SV', 'SW', 'T0', 'TA', 'TG', 'TK', 'TP', 'TU', 'UA', 'UL', 'UO', 'US', 'UX', 'V7', 'VS', 'WF', 'WS',
	'WY', 'YM', 'ZH', 'ZI'];

export const AIRPLANE_AIRBUS_EQUIPMENTS = [
	AIRPLANE_EQUIPMENT_CODE_32N,
	AIRPLANE_EQUIPMENT_CODE_32Q,
	AIRPLANE_EQUIPMENT_CODE_339,
	AIRPLANE_EQUIPMENT_CODE_332,
	AIRPLANE_EQUIPMENT_CODE_319,
	AIRPLANE_EQUIPMENT_CODE_321,
	AIRPLANE_EQUIPMENT_CODE_320
];

// MGP is only applicable to the markets with these currencies
// export const MGP_APPLICABLE_MARKETS = ['EUR', 'BRL', 'USD', 'GBP', 'CAD', 'DKK', 'NOK', 'PLN', 'RUB', 'SEK', 'CHF', 'HUF']; // not used anymore

export const MGP_CODE = 'MGP1';
export const MGP_MAXIMUM_NEGATIVE = 1800;
export const MGP_RT_INITIAL_DISCOUNT = 200;
export const MGP_OW_INITIAL_DISCOUNT = 100;



// flight haul types
export const FLIGHT_HAUL_TYPE_DOMESTIC = 'HAUL_DOMESTIC';
export const FLIGHT_HAUL_TYPE_SHORT = 'HAUL_SHORT';
export const FLIGHT_HAUL_TYPE_MEDIUM = 'HAUL_MEDIUM';
export const FLIGHT_HAUL_TYPE_LONG = 'HAUL_LONG';
export const FLIGHT_HAUL_TYPE_INTERLINE = 'HAUL_INTERLINE';

// payment methods (FOPs)
export const PAYMENT_METHOD_CREDIT_CARD = 'CC';
export const PAYMENT_METHOD_PAYPAL = 'PP';
export const PAYMENT_METHOD_ALIPAY = 'AP';
export const PAYMENT_METHOD_BANK_TRANSFER = 'BT';
export const PAYMENT_METHOD_KLARNA_PAY_NOW = 'SF';
export const PAYMENT_METHOD_KLARNA_PAY_LATER = 'KL';
export const PAYMENT_METHOD_REVOLUT = 'RV';
export const PAYMENT_METHOD_POLI = 'PI';
export const PAYMENT_METHOD_CARDLESS = 'CL';
// export const PAYMENT_METHOD_BANCONTAC = 'BC';
export const PAYMENT_METHOD_PRP = 'PR';
export const PAYMENT_METHOD_IDEAL = 'IL';
export const PAYMENT_METHOD_BANCONTACT_MOBILE = 'BM';
export const PAYMENT_METHOD_MULTICAIXA = 'MX';
export const PAYMENT_METHOD_MULTICAIXA_EXPRESS = 'ME';
export const PAYMENT_METHOD_PICKUP = "PU";
export const PAYMENT_METHOD_BANK_TRANSFER_BR = "SB";
export const PAYMENT_METHOD_LOTERIAS = "SC";
export const PAYMENT_METHOD_SAFETYPAY = "SP";
export const PAYMENT_METHOD_PIX = "PX";

export const PAYMENT_METHODS = [
	PAYMENT_METHOD_CREDIT_CARD,
	PAYMENT_METHOD_PAYPAL,
	PAYMENT_METHOD_ALIPAY,
	PAYMENT_METHOD_BANK_TRANSFER,
	PAYMENT_METHOD_KLARNA_PAY_NOW,
	PAYMENT_METHOD_KLARNA_PAY_LATER,
	PAYMENT_METHOD_POLI,
	PAYMENT_METHOD_PRP,
	PAYMENT_METHOD_IDEAL,
	PAYMENT_METHOD_BANCONTACT_MOBILE,
	PAYMENT_METHOD_MULTICAIXA,
	PAYMENT_METHOD_PICKUP,
	PAYMENT_METHOD_SAFETYPAY,
	PAYMENT_METHOD_CARDLESS
];

// prp codes
export const PAYMENT_METHOD_PRP_MB_WAY = 'MB';
export const PAYMENT_METHOD_PRP_ATM = 'AT';

export const PAYMENT_METHOD_PRPS = [
	PAYMENT_METHOD_PRP_MB_WAY,
	PAYMENT_METHOD_PRP_ATM,
	PAYMENT_METHOD_MULTICAIXA,
	PAYMENT_METHOD_PICKUP,
	PAYMENT_METHOD_BANK_TRANSFER
];

export const PAYMENT_METHOD_ASYNC = [
	PAYMENT_METHOD_PRP_MB_WAY,
	PAYMENT_METHOD_PRP_ATM,
	PAYMENT_METHOD_MULTICAIXA,
	PAYMENT_METHOD_PICKUP,
	PAYMENT_METHOD_BANK_TRANSFER,
	PAYMENT_METHOD_LOTERIAS,
	PAYMENT_METHOD_SAFETYPAY
];

// bank transfer markets
export const PAYMENT_METHOD_BANK_TRANSFER_MARKETS = [
	COUNTRY_CODE_ANGOLA,
	COUNTRY_CODE_CAPE_VERDE,
	COUNTRY_CODE_IVORY_COAST,
	COUNTRY_CODE_GHANA,
	COUNTRY_CODE_GUINEA_BISSAU,
	COUNTRY_CODE_MOZAMBIQUE,
	COUNTRY_CODE_SAO_TOME,
	COUNTRY_CODE_SENEGAL,
	COUNTRY_CODE_TOGO
];

// bank transfer FOPs
export const PAYMENT_METHOD_BANK_TRANSFERS = [
	PAYMENT_METHOD_BANK_TRANSFER
];

// credit card codes
export const PAYMENT_METHOD_CC_VISA = 'VI';
export const PAYMENT_METHOD_CC_MASTERCARD = 'MC';
export const PAYMENT_METHOD_CC_AMEX = 'AX';
export const PAYMENT_METHOD_CC_DINERS = 'DC';
export const PAYMENT_METHOD_CC_UATP = 'TP';
export const PAYMENT_METHOD_CC_HIPERCARD = 'HC';
export const PAYMENT_METHOD_CC_ELO = 'EL';
export const PAYMENT_METHOD_CC_CARTES_BANCAIRES = 'CB';
export const PAYMENT_METHOD_CC_DISCOVERCARD = 'DS';

export const PAYMENT_METHOD_CREDIT_CARDS = [
	PAYMENT_METHOD_CC_VISA,
	PAYMENT_METHOD_CC_MASTERCARD,
	PAYMENT_METHOD_CC_AMEX,
	PAYMENT_METHOD_CC_DINERS,
	PAYMENT_METHOD_CC_UATP,
	PAYMENT_METHOD_CC_HIPERCARD,
	PAYMENT_METHOD_CC_ELO,
	PAYMENT_METHOD_CC_CARTES_BANCAIRES,
	PAYMENT_METHOD_CC_DISCOVERCARD
];

// debit card codes
export const PAYMENT_METHOD_DC_VISA_DEBIT = 'VI';
export const PAYMENT_METHOD_DC_MAESTRO = 'MA';
export const PAYMENT_METHOD_DC_MASTERCARD_DEBIT = 'MC';
export const PAYMENT_METHOD_DC_BANCONTACT = 'BC';
// export const PAYMENT_METHOD_DC_VISA_DEBIT = 'VD';
// export const PAYMENT_METHOD_DC_MASTERCARD_DEBIT = 'MD';

export const PAYMENT_METHOD_DEBIT_CARDS = [
	PAYMENT_METHOD_DC_VISA_DEBIT,
	PAYMENT_METHOD_DC_MAESTRO,
	PAYMENT_METHOD_DC_MASTERCARD_DEBIT,
	PAYMENT_METHOD_DC_BANCONTACT
];


// payment flow types
export const PAYMENT_FLOW_MYB = 'MYBPayment';
export const PAYMENT_FLOW_BOOKING = 'BookingPayment';

// credit card payment types
export const PAYMENT_CC_TYPE_OCP = 'OCP';
export const PAYMENT_CC_TYPE_STORE_FOR_OCP = 'OCPSTORE';

// Insurance providers
export const INSURANCE_PROVIDER_CHUBB = 'Chubb';

// Paypal payment result
export const PAYPAL_PAYMENT_RESULT = {
	SUCCESS: 'success',
	SUCCESS_ISSUE_OK: 'success-issue-ok',
	SUCCESS_ISSUE_KO: 'success-issue-ko',
	SUCCESS_ISSUE_ERROR: 'success-issue-error',
	REJECTED: 'rejected',
	ERROR: 'error',
	TECHNICAL_ERROR: 'technical-error',
	PAID_ERROR: 'paid-error'
};

// PRP payment result
export const PRP_PAYMENT_RESULT = {
	SUCCESS: 'success',
	REJECTED: 'rejected',
	ERROR: 'error',
	TECHNICAL_ERROR: 'technical-error',
	PAID_ERROR: 'paid-error'
};

// generic payment result
export const PAYMENT_RESULT = {
	SUCCESS: 'success',
	REJECTED: 'rejected',
	ERROR: 'error',
	TECHNICAL_ERROR: 'technical-error',
	PAID_ERROR: 'paid-error'
};

// Cybersource fraud confirmation types
export const PAYMENT_CARDHOLDER_TRAVELLING = 'MSG1';
export const PAYMENT_CARDHOLDER_NOT_TRAVELLING = 'MSG2';

// Priority to suggest to user on use-miles sidebar
export const USE_MILES_EXTRAS_PRIORITY = [EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_BAG];


// Deeplink constants

export const DEEPLINK_DATES_PAGE = 'dates';
export const DEEPLINK_FLIGHTS_PAGE = 'flights';
export const DEEPLINK_FLIGHTS_PAGE_MULTICITY = 'flights-multicity';
export const DEEPLINK_FLIGHTS_PAGE_STOPOVER = 'flights-stopover';
export const DEEPLINK_MAIN_PAGE = "main";

export const DEEPLINK_FLIGHT_TYPE_SINGLE = 'single';
export const DEEPLINK_FLIGHT_TYPE_RETURN = 'return';
export const DEEPLINK_FLIGHT_TYPE_MULTICITY = 'openJaw';

export const DEEPLINK_PARAM_INBOUND = 'inbound';
export const DEEPLINK_PARAM_OUTBOUND = 'outbound';

export const DEEPLINK_PARAM_NETWORK_NAME = 'networkName';
export const DEEPLINK_PARAM_ORIGIN = 'origin';
export const DEEPLINK_PARAM_DESTINATION = 'destination';
export const DEEPLINK_PARAM_DEPARTURE_DATE = 'depDate';
export const DEEPLINK_PARAM_RETURN_DATE = 'retDate';
export const DEEPLINK_PARAM_ADULT = 'adt';
export const DEEPLINK_PARAM_CHILD = 'chd';
export const DEEPLINK_PARAM_INF = 'inf';
export const DEEPLINK_PARAM_FLIGHT_TYPE = 'flightType';
export const DEEPLINK_PARAM_MARKET = 'market';
export const DEEPLINK_PARAM_LANGUAGE = 'language';
export const DEEPLINK_PARAM_PROMOCODE = 'promocode';
export const DEEPLINK_PARAM_HASH = 'uh';
export const DEEPLINK_MAGIC_WORD = 'tap1945';
export const DEEPLINK_PARAM_VOUCHER = 'voucher';
export const DEEPLINK_STOPOVER_ROUTE_EXCEPTION = ['LIS', 'OPO'];

// cookies keys
export const COOKIES_VAR_KEY_PASSENGER_DETAILS = 'passengerDetails';
export const COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS = 'passengerContactDetails';

// local storage keys
export const LOCAL_STORAGE_VAR_KEY_CURRENT_SESSION_DATA = 'currentSessionData';
export const LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT = 'dontRedirect';
export const LOCAL_STORAGE_VAR_KEY_ROUTE_NAME = 'currentRouteName';

// payment page state route names
export const PAYMENT_LOGIN_STATE_ROUTE_NAME = '/booking/login';
export const PAYMENT_PASSENGERS_STATE_ROUTE_NAME = '/booking/passengers';
export const PAYMENT_CONTACTS_STATE_ROUTE_NAME = '/booking/contacts';
export const PAYMENT_PAYMENT_STATE_ROUTE_NAME = '/booking/payment';


// Third party extras type for confirmation page
export const EXTRAS_TOURS = 'CP_VIATOR_TOURS';
export const EXTRAS_TRANSFERS = 'CP_CARTRAWLER_TRANSFERS';
// export const EXTRAS_PARKING = 'CP_CARTRAWLER_PARKING';
export const EXTRAS_PARKING = 'PARKING';
export const EXTRAS_CRUISE = 'CP_ROYAL_CRUISE';
export const EXTRAS_ASSISTANCE = 'CP_TAP_ASSISTANCE';
export const EXTRAS_SELWO_MARINA = 'CP_PARQUESREUNIDOS_SELWO';
export const EXTRAS_PARK_WARNER = 'CP_PARQUESREUNIDOS_WARNER';
export const EXTRAS_NANNY_BAG = 'CP_NANNY_BAG';
export const EXTRAS_ESIM = 'ESIM';

// TTT statuses
export const TTT_STATUS_ACTIVE = 'active';
export const TTT_STATUS_PAID = 'paid';
export const TTT_STATUS_EXPIRED = 'expired';
export const TTT_STATUS_WAITING = 'waiting';
export const TTT_STATUS_NOT_FOUND = 'not-found';

// Passenger sidebar error translation keys
export const PAX_FF_MISMATCHNAME_ERROR_KEY = 'bookingDetails.error.insertCorrectInformation';

export const DISCOUNT_AMOUNT_TYPE_FIXED = 'FIXED';
export const DISCOUNT_AMOUNT_TYPE_PERCENTAGE = 'PERECENTAGE';
export const DISCOUNT_AMOUNT_TYPE_MILES = 'MILES';

export const DISCOUNT_APPLY_TO_TOTAL = 'TOTAL';
export const DISCOUNT_APPLY_TO_FARE = 'FARE';
export const DISCOUNT_APPLY_TO_YQ = 'YQ';

export const DISCOUNT_TYPE_PROMOCODE = 'promocode';
export const DISCOUNT_TYPE_VOUCHER = 'voucher';
export const DISCOUNT_TYPE_OTHERS = 'others';

export const DISCOUNT_STATUS_ACTIVE = 'active';
export const DISCOUNT_STATUS_INACTIVE = 'inactive';

// personal doc section (document APIs)
export const PERSONAL_DOC_API_ORIGIN_DEST_COUNTRIES = ['GB', 'PL', 'HU', 'LU', 'AT', 'SE', 'CZ', 'DK', 'NL', 'FI', 'US', 'CA', 'IT', 'IN'];
export const PERSONAL_DOC_API_PT_COUNTRY_ORIGIN_EXCEPTIONS = [
	'BG', 'BE', 'SK', 'SI', 'EE', 'ES', 'FR', 'GR', 'IS', 'IT', 'LV', 'LI', 'LT', 'MT', 'NO', 'CH', 'RO'
];
export const PERSONAL_DOC_EUROPE_COUNTRY_CODES = [
	'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
	'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PO', 'RO', 'SK', 'SI', 'ES', 'SE',
	'AL', 'AD', 'AM', 'BY', 'BA', 'FO', 'GE', 'GI', 'IS', 'IM', 'XK', 'LI', 'MK',
	'MD', 'MC', 'ME', 'NO', 'RU', 'SM', 'RS', 'CH', 'TR', 'UA', 'GB', 'VA'
];
export const PERSONAL_DOC_API_DEST_COUNTRIES_EXCEPTIONS = ['GB'];
export const PERSONAL_DOC_API_REQUIRED_COUNTRIES = ['US', 'CA'];
export const PAYMENT_ADDRESS_FIELDS_REQUIRED_MARKET = ['BR', 'US', 'CA'];

// award markets
export const AWARD_FLOW_MARKETS = ['PT', 'BR', 'US'];
export const AWARD_FLOW_MARKET_CURRENCY_MAP = {
	[COUNTRY_CODE_PORTUGAL]: 'EUR',
	[COUNTRY_CODE_USA]: 'USD',
	[COUNTRY_CODE_BRAZIL]: 'BRL'
};

export const FARE_API_FLIGHT_SEGMENT_ERROR = 'flight segments could not be confirmed';

// payment method params
export const PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE = 'merchantAccount_IBE';
export const PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE_AWARD = 'merchantAccount_IBE_Award';
export const PAYMENT_METHOD_PARAM_PTD = 'PTD';
export const PAYMENT_METHOD_PARAM_INSTALLMENT = 'installment';
export const PAYMENT_METHOD_PARAM_ENDDATETIME = 'endDatetime';
export const PAYMENT_METHOD_PARAM_TIMELIMIT = 'TL';

export const INSURANCE_INFO_REQUIRED_MARKETS = ['PT', 'IT'];

// payment failure notification error codes
export const PAYMENT_NOTIFICATION_ERROR_CODE_DECLINED_CC_VALIDATION = '30';
export const PAYMENT_NOTIFICATION_ERROR_CODE_MAX_PAYMENT_ATTEMPT = '31';

// update account sidebar source scenario
export const UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYWITHMILES_CHECKBOX = 'payWithMilesCheckbox';
export const UPGRADE_ACCOUNT_SIDEBAR_SOURCE_PAYMENT_PAGE = 'paymentPage';
export const UPGRADE_ACCOUNT_SIDEBAR_SOURCE_MG_BOTTOM_BAR = 'milesGoDiscountBottomBar';
export const UPGRADE_ACCOUNT_SIDEBAR_SOURCE_SLIDER_AND_EXTRAS = 'milesSliderAndPayExtras';

// Login types
export const LOGIN_AUTENTICATION_TYPE_TAP = "TP";
export const LOGIN_AUTENTICATION_TYPE_FACEBOOK = "FCB";
export const LOGIN_AUTENTICATION_TYPE_GOOGLE = "GOG";

// Social Login Keys
export const SOCIAL_FACEBOOK_KEY = "308768679500928";
export const SOCIAL_GOOGLE_KEY = "240096616372-r704qtltqtr6fc0si03i291p9camg58v.apps.googleusercontent.com";

export const COUNTRIES_TRANSLATION_KEY = 'countries.text.'

//Hand Baggage Info Banner - Activation
export const HAND_BAGGAGE_INFO_BANNER_ACTIVATION_FLAG = true;

//Default Session Extend
export const DEFAULT_SESSION_EXTEND_INTERVAL_IN_SECONDS = 300;
